const zh = {
    monthArr: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    noData: 'データなし',
    unit: {
        step: '歩',
        steps: '歩',
        day: '日',
        days: '日',
        time: '回',
        times: '回',
        km: 'キロ',
        hour: '時間',
        hours: '時間',
        kcal: '千カル',
    },
    dailyActive: {
        title: '日常の活動',
        tab0: '歩数',
        tab1: '運動エネルギー消費',
        tab2: '中高強度',
        unit0: '歩',
        unit1: '千カル',
        unit2: '分',
        time0: '周',
        time1: '月',
        time2: '年',
        time3: '日',
        math0: '最高',
        math1: '平均',
        math2: '目標達成率',
        descTitle: '運動エネルギー消費',
        desc: '運動エネルギー消費とはスポーツ活動に従事する際に消費されるエネルギーのことで、活動のタイプ、時間、強度などに基づいて計算され、基礎代謝は含まれていない。（基礎代謝とは、生体の体温、心拍、呼吸、血液循環などの基本的な生命活動を維持するために必要な最低エネルギー代謝であり、1日のうち時間とともに蓄積される。）',
        target: '目標進捗',
        targetSet: '目標設定',
        targetDesc0: '目標達成まであと',
        targetDesc1: '歩、急いで動き出そう~',
        targetDesc2: 'kcal、急いで動き出そう~',
        targetDesc3: '分、急いで動き出そう~',
        weekTitle: '週間統計',
        weekRatio: '歩数',
        weekDesc0: '今週は',
        weekDesc1: '歩歩いて、標準的な運動場を',
        weekDesc2: '周歩いたことに相当します。',
        weekCalDesc0: '今週は',
        weekCalDesc1: ' kcalを消費しました。に相当',
        weekDay: '日平均',
        weekDayDesc0: '日平均歩数は前の週に比べて、',
        weekDayDesc2: '日平均歩数は前の週と同じです。',
        weekDayCalDesc0: '日平均運動エネルギー消費量は前の週と比較して、',
        weekDayCalDesc2: '日平均の運動エネルギー消費量は前の週と同じだった。',
        weekDayAdd: 'ぞうか',
        weekDayReduce: '減少',
        weekDayDesc1: '歩。',
        weekDayCalDesc1: 'Kcal。',
        monthTitle: '月次統計',
        monthTitleProp: '(今月のデータには本日は含まれていません）',
        monthDayDesc0: '今月は1日平均',
        monthDayDesc1: '歩歩きました、先月より',
        monthDayDesc2: '歩。',
        monthDayDesc3: '歩、先月と同じだ。',
        monthCalDayDesc0: '今月は1日平均',
        monthCalDayDesc1: ' kcalを消費しています、先月より',
        monthCalDayDesc2: 'Kcal。',
        monthCalDayDesc3: 'Kcal、先月と同じだ。',
        monthSportStrengthDesc0: '今月は1日平均',
        monthSportStrengthDesc1: ' 分を消費しています、先月より',
        monthSportStrengthDesc2: '分。',
        monthSportStrengthDesc3: '分、先月と同じだ。',
        monthThis: '今月',
        monthLast: '先月',
        monthReach: '達成統計',
        monthReachDesc0: '今月の目標達成日数は前月比',
        monthReachDesc1: '日。',
        monthReachDesc2: '今月の目標達成日数は前月並み。',
        stepTargetTitle: '目標歩数',
        calTargetTitle: '目標カロリー',
        distance: 'きょり',
        cal: 'しょうひ',
        distanceUnit: '公里',
        calUnit: 'Kcal',
        abstract: 'アクティビティの概要',
        more: '詳細を表示',
        all: '合計歩数',
        weekReach: '目標達成日数',
        over: '目標は達成しました！続けて、あなたは活力と喜びを得ることができます！',
        and: '、',
        stepToDC0: '歩いたに等しい',
        stepToDC1: '周標準的な運動場を、消耗した',
        stepToDC2: '。',
        calTCal0: '消費することになります',
        allCal: '総消費量',
        noAbstract: 'データが不足しており、要約内容を示すことができません~',
        allStrength: '合計時間',
        strengthTitle: '中高強度',
        strengthDesc: '中高強度活動時間とは、歩調数（日常モード）または心拍数（運動モード）に基づいて統計を行い、中高強度レベルに達した活動の累計時間を指し、通常は毎日30分に達することを提案する。',

    },
    abstract: {
        title: 'アクティビティの概要'
    },
    hr: {
        title: '心拍数',
        unit: '回/分',
        resting: '静止',
        time0: '日',
        range: '範囲',
        avgHr: '平均心拍数',
        restingHr: '安静時心拍数',
        descTitle: '静止心拍数',
        desc: '静止心拍数は朝起きる前の空腹心拍数であり、心臓の健康をはかる重要な指標の一つである。理想的な静止心拍数は50 ~ 80回/分であり、理想的な範囲内でない人は心血管疾患が発生する確率が高く、適切な強度の運動を行うことで静止心拍数を理想的にすることができる。',
        desc1: '本機能はご参考までに、医療診断の根拠としてはなりませんので、不調があればすぐに医療機関にお問い合わせください。',
        conclude: {
            "无有效结果": '有効な結果なし；',
            "未见明显异常": '明らかな異常なし；',
            "疑似房颤": '心房細動の疑い；',
            "疑似心动过速": '頻脈の疑い；',
            "疑似心动过缓": '徐脈の疑い；',
            "疑似长RR间期": '長いRR間隔の疑い；',
            "疑似偶发室性早搏": 'エピソード性心室性早期収縮の疑い；',
            "疑似频发室性早搏": '頻回の心室性期外拍動の疑い；',
            "疑似室性心动过速": '心室頻拍の疑い；',
            "疑似偶发室上性早搏": 'エピソード性上室性早拍の疑い；',
            "疑似频发室上性早搏": '頻回の上室性早拍の疑い；',
            "疑似室上性心动过速": '上室性頻拍の疑い；'
        },
        suggest: {
            "心脏健康状况较好，请保持健康的生活习惯。": '心臓の健康状態は良好です。健康的な生活習慣を維持してください。',
            "请定期进行心电图监测，注意休息，保持生活规律。": '定期的に心電図を監視し、十分な休息をとり、生活の規則性を保ってください。',
            "请定期进行心电图监测，留意心率和心律变化情况，注意休息，保持生活规律。": '定期的に心電図を監視し、心拍数と心律の変化に注意してください。十分な休息をとり、生活の規則性を保ってください。',
            "请定期进行心电图监测，如有心慌、胸闷、头晕、晕厥等症状，建议去正规医院咨询和检查。": '定期的に心電図を監視し、心慌、胸闷、頭晕、晕厥などの症状がある場合は、正規の病院で相談と検査を受けられることをお勧めします。',
            "请加强心电图监测，如有心慌、胸闷、头晕、晕厥等症状，请及时去正规医院咨询和诊疗。": '心電図の監視を強化し、心慌、胸闷、頭晕、晕厥などの症状がある場合は、早期に正規の病院で相談と治療を受けられることをお勧めします。',
            "心电波形质量较差，请重新测量！":"心電波形の品質が悪いです。再度測定してください！"
        }
    },
    hrDesc: {
        title: '不整脈',
        title0: '頻脈',
        desc0: '瞬時心拍数が毎分100回を超える割合。 頻脈には生理的頻脈と病的頻脈がある。 生理的頻脈は、ランニングや感情的興奮などの条件下で心拍数が加速するもので、高体温や貧血などの疾患によって引き起こされる頻脈は病的頻脈と呼ばれる。',
        title1: '徐脈',
        desc1: '瞬時心拍数が1分間に60回未満の割合。 徐脈にはいくつかのタイプがあるが、最も一般的なのは洞性徐脈である。 心拍数が毎分50回未満のほとんどは病的であり、通常は治療が必要である。',
        title2: '不整脈または早発性拍動',
        desc2: '洞性不整脈または早発性拍動を説明する。 心室性期外収縮や上室性期外収縮を含む期外収縮は、健常人や様々な心臓病患者を含む様々な人に起こる非常に一般的な臨床不整脈である。 1秒間に5回未満の早発は随時性、5回以上は頻発性に分類される。',
        title3: '上室性早期拍動',
        desc3: '上室性期外収縮は、洞結節の外側で発生する心房の早発性興奮であり、健常人にもあらゆる心臓病患者にもみられる一般的な不整脈である。 上室性期外収縮の頻度は年齢とともに増加する。 上室性早拍の主な症状は動悸と心臓が止まる感じです。 上室性早期拍動の頻度は、1分間に5回または1時間に30回以上です。',
        title4: '心室早期収縮',
        desc4: '早発性心室収縮は、心室から発生する心臓のリズムの障害であり、健常人にもさまざまな心臓病の患者にも起こる非常に一般的な不整脈である。 早発性心室収縮の頻度は、健常人では年齢とともに増加する。 心室性期外収縮の最も一般的な症状は動悸であり、時に患者は心前庭部のドキドキ感やめまいを経験する。 頻回の心室性期外収縮は1分間に5回以上、または1時間に30回以上である。',
        title5: '心房細動',
        desc5: '心房細動は最も一般的な持続性不整脈で、心拍数が速く不規則であることが特徴である。 心房細動の発症率は冠動脈疾患、高血圧、心不全などの心臓病と密接な関係があり、加齢とともに増加し（75歳以上では10％に達する）、脳卒中などの重篤な合併症を引き起こすことがある。',
        title6: '長いRR間隔',
        desc6: '長いRR間隔は、一般に心電図において1.5秒以上のRR間隔と定義され、外来心電図における重要なモニタリング指標の1つである。 長いRR間隔を引き起こす最も一般的な不整脈の種類は、主に心房細動または心房粗動、洞停止、房室ブロックである。',
    },
    ecgDesc: {
        title: '心臓の健康スコア',
        title0: '心臓の健康スコア',
        desc0: '心臓の健康スコアは、この心電図測定から算出されたリズム解析と不整脈イベントに従って計算され、一定の重み付け戦略に従って、不整脈イベントとリズム異常が少なければ心臓の健康スコアが高いことを意味し、その逆であれば、具体的なスコア制御は以下のようになる：',
        level0: '悪い：＜60',
        level1: '平凡：60-69',
        level2: '通常：70-79',
        level3: '良好：80-89',
        level4: 'より良い：≥90',
        title1: '結論と提言',
        desc1: '不整脈イベントやリズム異常に基づいて自動的に生成されたもので、臨床診断の直接の根拠となるものではありません。 危険性が示唆されたり、身体に違和感を覚えたりした場合は、速やかに通常の医療機関でカウンセリングや検査を受けることをお勧めします。'
    },
    hrvDesc: {
        title: 'HRV指標',
        title0: 'HRV指標',
        desc0: 'HRV指数とは心拍変動性のことで、心拍リズムの時間変化を意味し、各心拍周期の微妙な時間変化とその規則性を分析するために用いられ、主に心臓の自律神経調節機能を反映する。 HRVが高ければ高いほど、神経による循環器系の調節機能が優れていることを意味する。 HRVが悪い場合は、安静と感情のコントロールに注意し、心臓の不快感などの問題がある場合は、適時に医師に相談して検査を受けてください。具体的なスコアは以下のように比較される：',
        level0: '悪い：0-21',
        level1: '真ん中：21-34',
        level2: 'むしょうに：34-47',
        level3: 'より良い：>47',
    },
    sleep: {
        title: '睡眠',
        time0: '日',
        time1: '周',
        time2: '月',
        fallAsleep: '眠り始める',
        wakeUp: '目を覚ます',
        level0: 'より良い',
        level1: '真ん中',
        level2: 'とは異なる',
        hour: ' 時 ',
        minute: ' 分',
        sleepStage: '睡眠段階',
        stage0: 'しみん',
        stage1: '浅い眠り',
        stage2: '急速眼球運動',
        stage3: '意識的',
        mathTitle: '睡眠統計',
        math0: '平均睡眠時間',
        math1: '最短睡眠時間',
        math2: '最長睡眠時間',
        ratioLevel0: '深い眠りの割合（参考值：20~60%）',
        ratioLevel1: '浅い眠りの割合（参考值：＜55%）',
        ratioLevel2: 'ファストアイの割合（参考值：10~30%）',
        ratioLevel3: '覚醒回数（参考値：≦1回）',
        ratioLevel4: '短時間睡眠',
        ratioNormal: '正常',
        ratioHigh: 'は高め',
        ratioLow: 'あまる',
        sportLevel: '運動強度',
        other: '睡眠のすすめ',
        stageTitle: '期間別統計',
        stageKey0: '深い睡眠の平均時間',
        stageKey1: '軽い睡眠の平均時間',
        stageKey2: '平均急速眼球運動持続時間',
        stageKey3: '平均覚醒時間',
        fallTitle: '就寝時間',
        dayTitle: '1日平均統計',
        averageDesc0: '今週の1日平均睡眠時間と先週の比較',
        averageDesc1: '今月の1日平均睡眠時間と先月の比較',
        averageDesc2: '上昇',
        averageDesc3: '減少',
        averageDesc5: 'フラットに保つ。',
        averageDesc4: '。',
        averageDesc6: '',
        averageDesc7: '',
        scoreTitle: '睡眠スコア',
        total: '総睡眠時間',
        duration: '時間',
        typical: '参照範囲',
        ahiNormal: '正常',
        ahiMild: '軽度',
        ahiModerate: '中度',
        ahiSevere: '重度',
        week1: '月',
        week2: '火',
        week3: '水',
        week4: '木',
        week5: '金',
        week6: '土',
        week0: '日',
        avgScore: '平均スコア',
        vsLastWeek: '(先週比)',
        vsLastMonth: '(先月比)',
        vsLastWeekTitle: '先週比',
        vsLastMonthTitle: '先月比',
        days: '日',
        scoreGe80: '(≥80)',
        score60to79: '(60~79)',
        scoreLe60: '(＜60)',
        suggestText: '今週は良い結果です！睡眠の質が改善されました。この調子で続けましょう。',
        hoursVsNeed: '睡眠時間と必要量',
        sleepEfficiency: '睡眠効率',
        avgSleepEfficiency: '平均睡眠効率',
        sleepConsistency: '睡眠の一貫性',
        avgRestorativeSleep: '平均回復睡眠',
        sleepStability: '睡眠の安定性',
        avgSleepStability: '平均睡眠の安定性',
        ahi: 'AHI',
        avgAhi: '平均AHI',
    },
    sleepShort: {
        title: '詳細',
        shortTitle: '短時間睡眠',
        shortDesc: '3時間未満かつ40分以上の単発の睡眠はすべて短時間睡眠として記録されます。短時間睡眠については現在睡眠段階分析に対応しておりません。',
        suggest: '仮眠のアドバイス',
        suggest0: '適切な仮眠時間を選びましょう',
        suggest1: '1. 午後が最適：多くの人にとって、午後1時から3時が仮眠に最適な時間帯です。この時間帯は体内時計が自然に疲労の谷間に入るため、午前中の仕事や学習による疲れを効果的に緩和できます。また、就寝時間まで十分な時間があるため、通常は夜間の睡眠を妨げません。',
        suggest2: '2. 遅い時間帯は避ける：午後3時以降の仮眠はできるだけ控え、特に午後5時以降の仮眠は避けましょう。これにより正常な睡眠リズムが乱れ、夜の入眠が難しくなる可能性があります。',
    },
    sleepStage: {
        title: '睡眠段階',
        desc0: '睡眠段階は、脳波や生理的な症状から研究の便宜上、人為的に区切られたものであり、実際には明確な線引きは困難である。 様々な睡眠段階は徐々に変化し、重なり合い、絡み合い、それぞれに重点が置かれる傾向がある。 人間の睡眠では、一晩に約4～6回の睡眠サイクルがあり、それらは互いに関連し合いながら毎週繰り返される。 心身の健康を維持するために、毎日十分な睡眠を確保することは非常に有益であり、研究によると、成人の適切な睡眠時間：6-10時間、睡眠時間は睡眠の質の唯一の基準ではなく、長時間の睡眠は必ずしも睡眠不足を補うものではなく、時には質の高い睡眠を得るために助長されていない、我々は睡眠の質を向上させるために仕事と休息時間を確保する必要があります。',
        title1: '深い眠りの段階',
        desc1: '脳波の周波数が著しく低下し、呼吸数と血圧も著しく低下し、脳が十分な休息を得ることができ、深い眠りの段階で目が覚めると、めまい、動悸、イライラなどの症状が現れる。深い眠りが長ければ長いほど、睡眠の質は向上するが、深い眠りが長すぎると、特定の病気の発症のシグナルかもしれないので、専門の医師に相談することをお勧めする。',
        title2: '浅い眠り段階',
        desc2: '脳波が遅くなり、心拍数と呼吸速度が遅くなり、人は眠りに入ったが目覚めやすくなり、浅い眠りは正常な現象であり、急速な目覚めに役立つが、浅い眠りの割合が大きすぎると、睡眠の質が保証されず、眠気が出やすくなる。',
        title3: 'レム期',
        desc3: '人間の眼球は急速に前後に動くが、その段階で人は通常、夢の中にいる。夢の中で人が動きをしないように、筋肉は弛緩した麻痺状態にある。',
        title4: '明晰期',
        desc4: '夜間の覚醒は本当の覚醒ではなく、人は自分が覚醒していることに気づかないことがあり、覚醒の臨界状態では、通常、覚醒時間の合計は睡眠時間の合計の10％未満である。',
    },
    bos: {
        title: '血中酸素飽和度',
        time0: '日',
        time1: '周',
        time2: '月',
        math0: '最高',
        math1: '最低',
        math2: '平均',
        level0: '正常',
        level1: '軽度低酸素症',
        level2: '中等度低酸素症',
        descTitle: '血中酸素飽和度',
        desc0: '血中酸素飽和度（SpO2）とは、血液中の酸素結合ヘモグロビン（HbO2）の体積が、結合可能な全ヘモグロビンの体積に占める割合、すなわち血液中の酸素濃度のことで、呼吸サイクルの重要な生理的パラメータである。',
        desc1: '酸素値の結果は、',
        desc2: '95～100パーセント正常',
        desc3: '90～94パーセント軽度低酸素',
        desc4: '70～89パーセント中等度低酸素',
        desc5: '本機能はあくまでも参考であり、医学的診断の根拠として使用するものではありません。 体調不良を感じた場合は、直ちに医療機関にご相談ください。'
    },
    pressure: {
        title: '肉体的ストレス',
        time0: '日',
        time1: '周',
        time2: '月',
        math0: '最高',
        math1: '最低',
        math2: '平均',
        level0: 'は高め',
        level1: 'は中程度',
        level2: 'は普通',
        level3: 'ほぐす',
        descTitle: '肉体的ストレス',
        desc0: 'このデバイスは、HRV（心拍変動）などのデータをもとに、アルゴリズムによって現在の負担圧力値を導き出す。 ストレス値によって、自分の体のストレス状態を把握することができ、ストレスが高まっているときは、タイムリーにストレスを軽減することが健康に役立つ。',
        desc1: '圧力結果の説明：',
        desc2: '1～29はリラックス',
        desc3: '30～59は普通',
        desc4: '60～79は中程度',
        desc5: '80～99は高め'
    },
    fitnessAge: {
        title: '体力年齢',
        time0: '周',
        time1: '月',
        unit: '歳',
        actualAge: '実年齢',
        math0: '最高',
        math1: '最低',
        descTitle: '体力年齢',
        desc: '体力年齢は最大酸素摂取量から導き出される。 一般的に、VO2maxが高いほど有酸素運動能力が高い。'
    },
    staminaLevel: {
        title: 'フィットネスレベル',
        time0: '周',
        time1: '月',
        math0: '最高',
        math1: '最低',
        math2: '平均',
        level0: '初学者',
        level1: 'スポーツ初心者',
        level2: 'チャレンジャー',
        level3: 'アスリート',
        level4: 'スポーツファン',
        level5: 'スポーツ・マニア',
        level6: 'エリートアスリート',
        unit0: 'フィットネスレベル',
        unit1: '有酸素',
        unit2: '無酸素',
        descTitle: 'フィットネスレベル',
        desc0: 'フィットネスレベルは、最適なパフォーマンスの可能性を示す複合指標である。 エアロビック・フィットネス・レベルは、中・長距離のパフォーマンスを行う能力を判断するために使用することができ、一方、無酸素フィットネス・レベルは、短・中距離のパフォーマンスを行う能力を判断するために使用することができる。',
        desc1: '体力レベル値は、',
        desc2: '10-19.9ビギナー',
        desc3: '20-29.9スポーツ・ノービス',
        desc4: '30-39.9チャレンジャー',
        desc5: '40-49.9アスリート',
        desc6: '50-59.9スポーツ・エンスージアスト',
        desc7: '60-69.9スポーツ・エンスージアスト',
        desc8: '70-80.9エリート・アスリートと表現される',
    },
    trainingLoad: {
        title: '短期負荷',
        time0: '周',
        time1: '月',
        math0: '最高',
        math1: '最低',
        math2: '平均',
        level0: '低い',
        level1: '最適な',
        level2: '高い',
        descTitle: '短期負荷',
        desc0: 'トレーニング負荷は、現在の身体的負荷のレベルを反映することができ、運動前に現在のトレーニングの強度と時間を調整することで、最適なトレーニングスケジュールを実現し、怪我のリスクを軽減することができます。',
        desc1: '短期負荷値の説明：',
        desc2: '＜0.8 低負荷',
        desc3: '0.8-1.5 負荷は最適だ',
        desc4: '＞1.5 負荷が高い'
    },
    trainingStatus: {
        title: 'トレーニングステート',
        time0: '周',
        time1: '月',
        level0: '無状態期間',
        level1: 'オーバートレーニング期間',
        level2: '訓練期間の停止',
        level3: '後退期間',
        level4: '維持期間',
        level5: 'リカバリ期間',
        level6: '進歩期',
        level7: 'デクレメント期間',
        descTitle: 'トレーニングステート',
        desc0: 'トレーニング状況とは、ランニングやサイクリングのトレーニング状況を評価する指標です。 過去7日間のトレーニング負荷や筋力レベルの推移を観察することで、その後の運動トレーニングの指針を得ることができます。',
        desc1: '無状態期間：過去7日間訓練なしまたは最初の訓練から7日未満',
        desc2: 'オーバートレーニング期間：トレーニング負荷を低減し、回復時間を増加することを提案する',
        desc3: '訓練期間の停止：訓練を開始して順方向の訓練適応を達成することを提案する',
        desc4: '後退期：訓練計画を点検し、訓練負荷を調整することを提案する',
        desc5: '維持期間：訓練負荷を高めて順方向の訓練適応を達成することを提案する',
        desc6: '回復期：体力レベルの低下を避けるために訓練負荷を適切に増加することを提案する',
        desc7: '進歩期：現在の訓練状態を維持することを提案する',
        desc8: '減量期間：トレーニング負荷を微調整するために、体力レベルの変化に注目することをお勧めします',
    },
    vo2max: {
        title: '最大酸素摂取量',
        time0: '周',
        time1: '月',
        level0: '悪い',
        level1: 'ふりょう',
        level2: '標準',
        level3: 'よい',
        level4: 'ずば抜けている',
        level5: 'トップ',
        math0: '最高',
        math1: '最低',
        math2: '平均',
        descTitle: '最大酸素摂取量',
        desc: '最大酸素摂取量は、激しい運動中に身体が酸素を吸収・利用する最高速度と定義できる。 個人の心肺体力を表すのによく使われる。',
        age: '(ねんれい'
    },
    lactate: {
        title: '乳酸閾値',
        time0: '周',
        time1: '月',
        math0: '最高',
        math1: '最低',
        math2: '平均',
        descTitle: '乳酸閾値',
        unit0: 'キロ',
        unit1: '回/分',
        type0: 'ペースとは',
        type1: '心拍数',
        desc0: '乳酸閾値ペースとは、運動中に身体が耐えられる乳酸濃度（最大心拍数の約88～92％）での最速のランニングペース。',
        desc1: '最大乳酸定常状態(MLSS)は運動中に到達する。 乳酸閾値心拍数はこの段階で発生し、一般的に最大心拍数の88～92%に該当し、この心拍数を下回ると運動強度は長時間疲労することなく運動を継続できることを示す。'
    },
    forecast: {
        title: 'ランニング成績予測',
        title0: '最新の成績',
        level2: '半馬',
        level3: '全馬',
        title1: '最高の成績',
        descTitle: 'ランニング成績予測',
        desc: 'ユーザーの体力レベルの状態に基づいて、個人が異なる距離を走っている間に達成できる最高の成績を推定し、長い間にランニングの成績が向上したことを監視します。',
        prot: '日付'
    },
    basicHr: {
        title: '基礎心拍数',
        time0: '周',
        time1: '月',
        unit: '回/分',
        math0: '最大心拍数',
        math1: '最低心拍数',
        math2: '平均基礎',
        descTitle: '基礎心拍数',
        desc: '基礎心拍数とは、早朝起床前の空腹時の心拍数のことで、心臓の健康状態を示す最も重要な指標のひとつである。 理想的な基礎心拍数は毎分50～80拍で、この範囲にない人は心血管系疾患の可能性が高く、適切な強度で運動することで基礎心拍数を理想的な値にすることができる。',
        desc0: '本機能はご参考までに、医療診断の根拠としてはなりませんので、不調があればすぐに医療機関にお問い合わせください。'
    },
    sportType: {
        其他: 'その他',
        全部运动: 'すべてのスポーツ',
        健走: '歩行',
        跑步: 'ランニング',
        骑行: 'サイクリング',
        室内游泳: '室内水泳',
        户外游泳: '屋外水泳',
        操场跑: 'トラックランニング',
        徒步越野: 'トレイルハイキング',
        徒步穿越: 'トレッキング',
        马拉松: 'マラソン',
        铁人三项: 'トライアスロン',
        深蹲: 'スクワット',
        划船机: 'ローイングマシン',
        椭圆机: 'エリプティカルトレーナー',
        卷腹: 'クランチ',
        自由训练: 'フリートレーニング',
        跳绳: '縄跳び',
        俯卧撑: '腕立て伏せ',
        平板支撑: 'プランク',
        室内跑: '室内ランニング',
        射箭: 'アーチェリー',
        拳击: 'ボクシング',
        爬楼: '階段昇降',
        越野跑: 'クロスカントリーランニング',
        登山: '登山',
        轮滑: 'ローラースケート',
        骑马: '乗馬',
        皮划艇: 'カヤック',
        冲浪: 'サーフィン',
        帆板: 'ウィンドサーフィン',
        越野骑行: 'オフロードサイクリング',
        越野滑雪: 'クロスカントリースキー',
        滑雪登山: 'スキー登山',
        室内攀岩: '室内ロッククライミング',
        户外攀岩: '屋外ロッククライミング',
        飞盘: 'フリスビー',
        跳伞: 'スカイダイビング',
        篮球: 'バスケットボール',
        足球: 'サッカー',
        网球: 'テニス',
        羽毛球: 'バドミントン',
        乒乓球: '卓球',
        力量训练: '筋力トレーニング',
        室内步行: '室内歩行',
        障碍赛跑: '障害物競走',
        越野摩托: 'モトクロス',
        摩托艇: 'モーターボート',
        漂流: 'ラフティング',
        风筝冲浪: 'カイトボーディング',
        滑水: '水上スキー',
        浮潜: 'シュノーケリング',
        赛艇: 'ローイング',
        龙舟: 'ドラゴンボート',
        跳水: '飛び込み',
        有氧运动: '有酸素運動',
        室内单车: '室内サイクリング',
        踏步机: 'ステッパー',
        爬楼机: 'ステップクロマシン',
        漫步机: 'エリプティカルウォーカー',
        瑜伽: 'ヨガ',
        普拉提: 'ピラティス',
        空手道: '空手',
        跆拳道: 'テコンドー',
        HIIT: 'HIIT',
        体操: '体操',
        单杠: '鉄棒',
        双杠: '平行棒',
        户外滑冰: '屋外スケート',
        室内滑冰: '室内スケート',
        单板滑雪: 'スノーボード',
        双板滑雪: 'スキー',
        冰壶: 'カーリング',
        雪地摩托: 'スノーモービル',
        雪橇: 'そり滑り',
        雪车: 'ボブスレー',
        雪鞋徒步: 'スノーシューイング',
        蹦极: 'バンジージャンプ',
        跑酷: 'パルクール',
        BMX: 'BMX',
        赛车: '自動車レース',
        水球: '水球',
        排球: 'バレーボール',
        棒球: '野球',
        橄榄球: 'ラグビー',
        曲棍球: 'ホッケー',
        门球: 'ゲートボール',
        板球: 'クリケット',
        台球: 'ビリヤード',
        保龄球: 'ボウリング',
        匹克球: 'ピックルボール',
        壁球: 'スカッシュ',
        垒球: 'ソフトボール',
        冰球: 'アイスホッケー',
        手球: 'ハンドボール',
        舞蹈: 'ダンス',
        太极拳: '太極拳',
        健身操: 'エアロビクス',
        武术: '武術',
        击剑: 'フェンシング',
        滑板: 'スケートボード',
        摔跤: 'レスリング',
        钓鱼: '釣り',
        体感游戏: 'モーションセンシングゲーム'
    },
    challengeType: {
        type: 'シングルプレーヤー競争',
        attribute0: {
            name: 'タイムトライアル',
            attribute: 'タイムトライアル',
            desc0: 'チャレンジサイクルの中で、運動距離は最大',
            desc1: 'まで累積され、運動時間が短いほどランキングは高くなります。 (運動後、データを同期してください。ランキングはリアルタイムで更新されます）'
        },
        attribute1: {
            name: '距離競争',
            attribute: '距離競争',
            desc: 'チャレンジサイクル内では、運動の累積距離が長いほどランキングが高くなります。 (キャンペーン終了後、データを同期してください。リーダーボードはリアルタイムで更新されます）。'
        },
        attribute1骑行: {
            name: 'サイクリングに挑戦',
            attribute: '距離競争',
            desc: 'チャレンジサイクル中の累積走行距離が長いほど、ランキングは高くなります。 (走行後、データを同期してください。リーダーボードはリアルタイムで更新されます）。'
        },
        attribute1跑步: {
            name: 'ランニングに挑戦',
            attribute: '距離競争',
            desc: 'チャレンジサイクル内では、ランの累積距離が長いほどランキングが高くなります。 (走った後、データを同期してください。リーダーボードはリアルタイムで更新されます）。'
        },
        attribute2: {
            name: '脂肪燃焼コンテスト',
            attribute: '脂肪燃焼コンテスト',
            desc: 'チャレンジ期間中、指定された運動で消費したカロリーが多ければ多いほどランキングが上がります。 (運動後にデータを同期してください。リーダーボードはリアルタイムで更新されます)'
        },
        attribute3: {
            name: 'スピードウェイ・レース',
            attribute: 'スピードウェイ・レース',
            desc: 'チャレンジサイクル中、1レースの平均速度が速いほどランキングは高くなります。(トレーニング後にデータを同期してください。リーダーボードはリアルタイムで更新されます）。'
        },
        attribute3骑行: {
            name: '自転車スピードレース',
            attribute: 'スピードウェイ・レース',
            desc: 'チャレンジサイクル中の1回のライドの平均速度が速いほど、ランキングは高くなります。(ライド後にデータを同期してください。リーダーボードはリアルタイムで更新されます）。'
        },
        attribute3跑步: {
            name: 'ランニング・スピードレース',
            attribute: 'スピードウェイ・レース',
            desc: 'チャレンジサイクル中、1回のランの平均ペースが速いほどランキングは高くなります。(走った後にデータを同期してください。リーダーボードはリアルタイムで更新されます)'
        },
        attribute4: {
            name: 'ステップチャレンジ',
            type: 'シングルプレーヤー競争',
            desc: '歩数が多いほどランキングは上位になります（運動後にデータを同期してください。ランキングリストはリアルタイムで更新されます）。',
        }
    },
    challengeList: {
        title: '困難に立ち向かう',
        history: '歴史',
        join: '参加者数'
    },
    challengeDesc: {
        medalPop: '優勝おめでとう！',
        accept: '受け入れる',
        over: 'クローズド',
        no0: '',
        no1: '位',
        end0: '終了まであと',
        end1: '日',
        rDistance0: '残距離',
        distanceUnit: 'キロ',
        tDistance: '総距離',
        race: '最速ペース',
        cal: '総脂肪燃焼量',
        calUnit: 'kcal',
        step: '総歩数',
        stepUnit: '歩',
        down: 'ドロップダウン',
        up: 'プルアップ',
        range: 'チャレンジサイクル',
        type: '類型論',
        typeValue: 'シングルプレーヤー競争',
        attribute: 'チャレンジ属性',
        attributeArr: ['タイムトライアル', '距離競争', '脂肪燃焼コンテスト', 'スピードウェイ・レース', 'シングルプレーヤー競争'],
        sport: '運動タイプ',
        tab0: '詳細',
        tab1: 'ランキング',
        descTitle: '説明',
        top3: 'ベスト3勲章',
        medalFinish: '今回の挑戦を勝ち取ったのは',
        noMedal: '勲章をもらっていないので、次は頑張ってね~',
        joining: '今すぐ参加',
        tableTitle0: '順位',
        tableTitle1: 'ユーザー',
        tableTitle2: 'ざんりゅうきょり',
        tableTitle3: '時間を使う',
        tableTitle4: 'ぜんきょり',
        tableTitle5: '総脂肪燃焼量',
        tableTitle6: '最速ペース',
        tableTitle7: '総歩数',
        join: '参加者数'
    },
    sportRecord: {
        title: '運動記録',
        record0: {
            name: '歩数',
            record0: '1日の最多歩数記録(歩)',
            record1: '1週間の最大記録数(歩)',
            record2: '単月最多記録(歩)'
        },
        record1: {
            name: '走る',
            record0: '1旅行あたりの最大走行距離(キロ)',
            record1: 'さいてきはいそくど',
        },
        record2: {
            name: '乗る',
            record0: '1旅行あたりの最大走行距離(キロ)',
            record1: 'さいてきはいそくど',
        },
        record3: {
            name: '泳ぐ',
            record0: '1旅行あたりの最大走行距離(キロ)',
            record1: '最適なSWOLF',
        },
        record4: {
            name: '登山',
            record0: 'シングル最大高さ(メートル)',
        }
    },
    sportCount: {
        title: '運動統計',
        time0: '周',
        time1: '月',
        unit0: 'キロ',
        unit1: '分',
        item1: '運動回数',
        item1Unit: '回',
        item2: '運動時間',
        item2Unit: '時間',
        item3: 'ぜんきょり',
        item4: '運動エネルギー消費',
        item4Unit: 'kcal',
    },
    newSportList: {
        title: 'モーションレポート',
        type0: '運動週報',
        type1: '運動月報',
        type2: '運動年報',
    },
    newWeek: {
        title: '運動週報',
        step: '歩',
        day: '日',
        stepDesc0: '今週、あなたは人口の',
        stepDesc1: '以上を歩いた',
        time: '回',
        km: 'キロ',
        hour: '時間',
        kcal: 'kcal',
    },
    newMonth: {
        title: '運動月報',
        step: '歩',
        steps: '歩',
        day: '日',
        days: '日',
        time: '回',
        times: '回',
        km: 'キロ',
        hour: '時間',
        hours: '時間',
        kcal: 'kcal',
        noMedal: '勲章は追加されていないので、来月頑張ります~',
        add0: '新たに',
        add1: '個',
        more0: '',
        more1: 'を超える人'
    },
    newWeekHistory: {
        title: '歴史週報',
        no: '下にはないよ~'
    },
    newMonthHistory: {
        title: '歴史月報',
        no: '下にはないよ~'
    },
    feedback: {
        title: '意見のフィードバック',
        prop: 'あなたが直面している問題を説明したり、最適化の提案をしたりしてください。私たちは必ず真剣に対応します！',
        contact: '連絡先',
        contactValue: '携帯電話番号/QQ/ウィーチャット/メールボックス',
        submit: '送信'
    },
    medal: {
        title: '私の勲章',
        tab0: '運動勲章',
        tab1: '北斗勲章',
        tab2: 'チャレンジ勲章',
        get0: '勲章を',
        get1: '個受章した',
        step: '歩く',
        run: 'ランニング',
        ride: 'に乗る',
        swim: 'スイミング',
        climb: '山に登る',
        marathon: 'マラソン',
        sport: '運動'
    },
    selectCityApp: {
        title: 'としせんたく',
        current: '現在の都市',
        placeholder: '都市名を入力してください'
    },
    prodInstructions: {
        title: '操作の説明',
        video: '操作ビデオ',
        desc: '詳細な説明',
        quick: 'クイックスタートガイド',
        question: 'よくある質問',
        compass: '羅針盤の検査は正しくありませんか？',
        compass700: '羅針盤の検査は正しくありませんか？',
        sleep: '時計を正常に装着しても睡眠データはありません？',
        height: '標高が悪い？',
        ecg: '心電が測定できない/結果が正確ではない？',
        android: 'Android携帯電話のメッセージは時計にプッシュできませんか？',
        ios: 'iOSの携帯電話のメッセージは時計にプッシュできませんか？',
        keepAlive: 'どのようにして保活設定を行いますか？',
        restricted: '携帯電話のオープン権限プロンプト「制限された設定」？',
        map: '地図をダウンロードする方法は？'
    },
    keepAlive: {
        title: '保活設定',
        desc: 'Aswear Globalがバックグラウンドで正常に動作し、Bluetooth接続が安定していることを保証するために、ユーザーは以下の対応機種を参照して設定することができます。',
        tabArr: ['xiaomi', 'ファーウェイ', 'vivo', 'OPPO', 'ワン・プラス', 'realme', 'Honor', 'レノボ', 'MEIZU', 'サムスン'],
        xiaomi: {
            p0: '1 xiaomi',
            p1: '1.1 小米携帯電話でバックグラウンド活動を許可',
            p2: '設定]-[電話設定]-[アプリケーション設定]-[アプリケーション管理]-[Aswear Global]-[省電力ポリシー]-[無制限]に設定するをタップします。',
            p3: '1.1.1 アプリケーション設定',
            p4: '1.1.2 アプリケーション管理',
            p5: '1.1.3 Aswear Global',
            p6: '1.1.4 省電力ポリシー',
            p7: '1.1.5 無制限',
            p8: '1.2 小米携帯電話の自動起動権限設定',
            p9: '設定]-[電話設定]-[アプリケーション設定]-[アプリケーション管理]-[アスウェア]-[セルフスタート]-[セルフスタート]を有効にする]をタップします。',
            p10: '1.2.1 アプリケーション設定',
            p11: '1.2.2 アプリケーション管理',
            p12: '1.2.3 Aswear Global',
            p13: '1.2.4 自己始動スイッチを入れる',
            p14: '1.3 バックグラウンドタスクのロック',
            p15: '①下を長押しして上にスワイプすると、バックグラウンドタスクが表示されます；',
            p16: '②Aswear Global」アプリを長押しし、「ロック」アイコンをタップしてアプリをロックする。'
        },
        huawei: {
            p0: '2 ファーウェイ',
            p1: '2.1 ファーウェイ携帯ロックバックグラウンドタスク',
            p2: '画面下部から上にスライド-マルチタスクページに移動-Aswear Globalを見つける-Aswear Globalを下にスライド-Aswear Globalをロックします。',
            p3: '2.2 ファーウェイ携帯電話はバックグラウンド活動を許可',
            p4: '「設定」→「携帯電話の設定」→「アプリケーションとサービス」→「アプリケーション起動管理」→「Aswear Global」をクリックして、「自己起動を許可」と「バックグラウンド活動を許可」のスイッチをオンにします。',
            p5: '2.2.1 アプリケーションとサービス',
            p6: '2.2.2 アプリケーション起動管理',
            p7: '2.2.3 Aswear Global',
            p8: '2.2.4 自己起動を許可',
            p9: '2.2.5 [OK]をクリックします'
        },
        vivo: {
            p0: '3 vivo',
            p1: '3.1 vivo携帯電話でバックグラウンド活動を許可',
            p2: '「設定」→「携帯電話設定」→「バッテリ」→「バックグラウンド高消費電力」→「Aswear Global」をクリックして、「バックグラウンド高消費電力」をオンにします。',
            p3: '3.1.1 バッテリ',
            p4: '3.1.2 バックグラウンド高消費電力',
            p5: '3.1.3 Aswear Global',
            p6: '3.1.4 バックグラウンドの高消費電力をオンにする',
            p7: '3.2 vivo携帯電話の自己起動権限設定',
            p80: '推奨操作：【携帯電話設定】で「自己起動」を検索し、自己起動管理ページに入り、本APPオープン許可自己起動を選択すればよい。',
            p8: '「設定」→「携帯電話設定」→「アプリケーションと権限」→「権限管理」→「自己起動」→「Aswear Global」をクリックして、「自己起動」をオンにします。',
            p9: '3.2.1 適用と権限',
            p10: '3.2.2 権限管理',
            p11: '3.2.3 自己起動',
            p12: '3.2.4 Aswear Globalスイッチをオンにする'
        },
        oppo: {
            p0: '4 OPPO',
            p1: '4.1 OPPO携帯電話でバックグラウンド活動を許可',
            p2: '設定→【バッテリ】→【消費電力管理の適用】→【Aswear Global】をクリックして、【完全なバックグラウンド動作を許可】→ポップアップ設定【許可】をオンにします。',
            p3: '4.1.1 バッテリ',
            p4: '4.1.2 消費電力管理の適用',
            p5: '4.1.3 Aswear Global',
            p6: '4.1.4 完全なバックグラウンド動作を許可',
            p7: '4.1.5 クリック許可',
            p8: '4.2 OPPO携帯電話の自己起動権限設定',
            p9: '「設定」→「携帯電話の設定」→「アプリケーション管理」→「自己起動管理」→「Aswear Global」→「バックグラウンド自己起動」をオンにします。',
            p10: '4.2.1 アプリケーション管理',
            p11: '4.2.2 自己起動管理',
            p12: '4.2.3 Aswear Globalスイッチをオンにする'
        },
        yijia: {
            p0: '5 ワン・プラス',
            p1: '5.1 携帯電話によるバックグラウンドタスクのロック',
            p2: '画面下部から上にスライド-マルチタスクページに進む-Aswear Globalを見つける-詳細ボタンをクリック-Aswear Globalをロックするをクリックします。',
            p3: '5.2 携帯電話1台でバックグラウンド活動を許可',
            p4: '設定→【携帯電話の設定】→【バッテリ】→【消費電力管理の適用】→【Aswear Global】をクリックして、【完全なバックグラウンド動作を許可】→【許可】に設定します。',
            p5: '5.2.1 バッテリ',
            p6: '5.2.2 消費電力管理の適用',
            p7: '5.2.3 Aswear Global',
            p8: '5.2.4 完全なバックグラウンド動作を許可',
            p9: '5.2.5 クリック許可',
            p10: '5.3 携帯電話の自動起動権限設定の追加',
            p11: '設定→【携帯電話の設定】→【アプリケーション管理】→【自己起動管理】→【Aswear Global】→【バックグラウンド自己起動】をクリックします。',
            p12: '5.3.1 アプリケーション管理',
            p13: '5.3.2 自己起動管理',
            p14: '5.3.3 Aswear Global'
        },
        realme: {
            p0: '6 realme',
            p1: '6.1 realme携帯ロックバックグラウンドタスク',
            p2: '画面下部から上にスライド-マルチタスクページに進む-Aswear Globalを見つける-詳細ボタンをクリック-Aswear Globalをロックするをクリックします。',
            p3: '6.2 realme携帯電話によるバックグラウンド活動の許可',
            p4: '設定→【携帯電話の設定】→【バッテリ】→【消費電力管理の適用】→【Aswear Global】をクリックして、【完全なバックグラウンド動作を許可】→【許可】に設定します。',
            p5: '6.2.1 バッテリ',
            p6: '6.2.2 消費電力管理の適用',
            p7: '6.2.3 Aswear Global',
            p8: '6.2.4 完全なバックグラウンド動作を許可',
            p9: '6.2.5 クリック許可',
            p10: '6.3 realme携帯電話の自己起動権限設定',
            p11: '設定→【携帯電話の設定】→【アプリケーション管理】→【自己起動管理】→【Aswear Global】→【バックグラウンド自己起動】をクリックします。',
            p12: '6.3.1 アプリケーション管理',
            p13: '6.3.2 自己起動管理',
            p14: '6.3.3 Aswear Global'
        },
        rongyao: {
            p0: '7 Honor',
            p1: '7.1 Honor携帯電話のバックグラウンドタスクをロックする',
            p2: '画面下から上にスワイプ - マルチタスクページに移動 - Aswear Globalを探す - Aswear Globalを下にスワイプ - Aswear Globalをロック。',
            p3: '7.2 Honor携帯電話のバックグラウンド活動を許可する',
            p4: '設定]-[電話設定]-[アプリとサービス]-[アプリ起動管理]-[Aswear Global]をタップし、[自己起動を許可]と[バックグラウンド動作を許可]のスイッチをオンにします。',
            p5: '7.2.1 アプリとサービス',
            p6: '7.2.2 アプリ起動管理',
            p7: '7.2.3 Aswear Global',
            p8: '7.2.4 バックグラウンド動作を許可',
            p9: '7.2.5 OKをクリック'
        },
        lianxiang: {
            p0: '8 レノボ',
            p1: '8.1 レノボ携帯でバックグラウンド活動を許可',
            p2: '設定]-[電話設定]-[アプリと通知]-[特別なアプリの許可]-[バッテリーの最適化]-[Aswear Global]をタップし、ポップアップウィンドウで[最適化しない]を選択し、[完了]をタップします。',
            p3: '8.1.1 アプリと通知',
            p4: '8.1.2 特別なアプリの許可',
            p5: '8.1.3 バッテリーの最適化',
            p6: '8.1.4 Aswear Global',
            p7: '8.1.5 最適化しない選択',
            p8: '8.1.6 クリックして完了',
            p9: '8.2 レノボ携帯電話のセルフブート許可設定',
            p10: '設定]-[電話設定]-[アプリと通知]-[すべてのアプリを表示]-[Aswear Global]-[アクセス許可]-[アプリの自己起動]をタップし、ポップアップウィンドウで[許可]を選択し、[完了]をクリックします。',
            p11: '8.2.1 アプリと通知',
            p12: '8.2.2 すべてのアプリを表示',
            p13: '8.2.3 Aswear Global',
            p14: '8.2.4 アクセス許可',
            p15: '8.2.5 アプリの自己起動',
            p16: '8.2.6 許可'
        },
        meizu: {
            p0: '9 MEIZU',
            p1: '9.1 Meizuの携帯電話でバックグラウンド活動を許可する',
            p2: '設定]-[電話設定]-[プライバシーとアクセス許可]-[バックグラウンド管理]-[Aswrar]をタップし、[バックグラウンド実行を許可]を選択します。',
            p3: '9.1.1 プライバシーとアクセス許可',
            p4: '9.1.2 バックグラウンド管理',
            p5: '9.1.3 Aswear Global',
            p6: '9.1.4 バックグラウンド実行を許可',
            p7: '9.2 Meizu携帯電話のバックグラウンドタスクをロックする',
            p8: '画面下部から上にスワイプ - マルチタスクページに移動 - Aswear Globalを探す - Aswear Globalを下にスワイプ - Aswear Globalをタップしてロックする。'
        },
        sanxing: {
            p0: '10 サムスン',
            p1: '10.1 サムスン携帯電話のロックバックグラウンドタスク',
            p2: '画面下から上にスワイプ - マルチタスクページに移動 - Aswear Globalを探す - Aswear Globalを長押し - タップしてAswear Globalをロックする。',
            p3: '10.2 サムスン携帯、バックグラウンド活動を許可',
            p4: '設定]-[電話設定]-[アプリ]-[Aswear Global]-[バッテリー]をタップし、[バックグラウンド動作を許可]をオンにします。',
            p5: '10.2.1 アプリ',
            p6: '10.2.2 Aswear Global',
            p7: '10.2.3 バッテリー',
            p8: '10.2.4 バックグラウンド動作を許可',
            p9: '10.3 サムスン携帯電話のセルフブート許可設定',
            p10: '設定]-[電話設定]-[一般管理]-[バッテリー]-[バックグラウンド使用制限]-[自動的に実行されるアプリ]-[Aswear Global]-[バックグラウンドアクティビティの許可]をタップします。',
            p11: '10.3.1 一般管理',
            p12: '10.3.2 バッテリー',
            p13: '10.3.3 バックグラウンド使用制限',
            p14: '10.3.4 自動的に実行されるアプリ',
            p15: '10.3.5 バックグラウンドアクティビティの許可',
            p16: '【より多くの知識】',
            p17: '携帯電話でアクセス許可を開くと「制限された設定」が表示される問題の解決策'
        }
    },
    androidMessageSet: {
        title: 'Android携帯のメッセージが時計にプッシュされない？',
        p0: 'メッセージプッシュの原則：',
        p1: '時計がアンドロイド携帯電話に接続されると、システムは携帯電話の通知バーから通知を取得し、時計にプッシュします。',
        p2: '対応するアプリケーションメッセージが腕時計に受信されていないことに気づいた場合は、ウィーチャットを例にして、次の操作を試してみてください。',
        p3: '',
        p4: '',
        p5: '',
        p6: '',
        p7: '1.携帯電話の設定に入り、「権限管理＞右上コーナー＞特殊アクセス権限＞使用権の通知＞Aswear Global APP」を検索して入力します。',
        p8: '',
        p8end: '',
        p9: '2.「Aswear GlobalAPP>マイデバイス>メッセージリマインダ」で、メッセージをプッシュするアプリケーションスイッチをオンにします。',
        p10: '',
        p11: '',
        p12: '3.携帯電話の通知欄に情報が表示されることを確認する：ここではHarmonyOS 3.0携帯電話を例にして、「設定＞通知とステータス欄」を選択し、通知が必要なアプリケーションをクリックし、通知を許可するように設定し、そのアプリケーションの各カテゴリのメッセージの通知方式（着信音、振動、バナー、ロック画面通知、邪魔を許可、またはデスクトップアイコンの角標など）を設定し、サイレント通知スイッチをオフにする。',
        p13: '',
        p14: '',
        p15: '',
        p16: '',
        p17: '',
        p18: '',
        p19: '①通知とステータスバーに入る②対応アプリケーションの通知スイッチを入れる（ウィーチャットを例にした）',
        p20: '',
        p21: '',
        p22: '③許可通知スイッチをオンにする④その他の種別のメッセージ通知設定（新しいメッセージ通知を例に：許可通知と邪魔を許可し、サイレント通知をオフにする）。',
        p23: '',
        p24: '',
        p25: '',
        p26: '',
        p27: '',
        p28: '',
        p29: '',
        p31: '4.微信メッセージがプッシュされないか、情報の詳細が表示されない場合は、微信をオンにし、「マイ>設定>新メッセージリマインダ」を選択し、新メッセージ通知の受信とメッセージの詳細表示を通知するスイッチをオンにし、微信メッセージの内容が携帯電話のステータスバーに正常に表示されることを確認します。',
        p32: '',
        p33: '',
        p34: '',
        p35: '',
        p36: '',
        p37: '',
        p38: '①新規メッセージ通知に入る②メッセージ詳細とメッセージ通知を表示する通知スイッチを入れる',
        p39: '',
        p40: '',
        p41: '',
        p42: '',
        p43: '',
        p44: '',
        p45: '*WeChatコンピュータ版にログインする場合は、WeChatの携帯電話の静音機能がオフになっていることを確認してください：携帯電話の端にあるWeChatのトップページでバナー通知をクリックしてから、携帯電話を静音にして、このボタンを灰色にします。',
        p46: '',
        p47: '',
        p48: '',
        p49: '',
        p50: '',
        p51: '',
        p52: '5.携帯電話にAswear Global APPを保護されたバックグラウンドアプリケーションとして設定し、携帯電話を再起動することを強くお勧めします。設定すると、メッセージ送信の安定性が向上します。設定方法はアプリ保活設定を参考にして、ジャンプをクリックしてください。',
        p53: '6.時計と携帯電話を再起動してみてください。',
        p54: '7.問題が残っている場合は、腕時計とAswear Global APPを最新バージョンにアップグレードし、接続を再ペアリングします。',
        p55: '*Aswear Global APPの更新：Aswear Global APP>マイ>APP>APPバージョンの更新について。',
        p56: '腕時計：Aswear Global APP>マイデバイス>ファームウェアアップデート。'
    },
    iosMessageSet: {
        title: 'IOS携帯電話のメッセージは腕時計にプッシュできない？',
        p0: 'メッセージプッシュの原理：',
        p1: '腕時計がiOS携帯に接続されると、iOSシステムは携帯電話の通知欄の通知を取得し、あなたの腕時計にプッシュします。',
        p2: '3.対応するアプリケーションメッセージが腕時計に受信されていないことに気づいた場合は、ウィーチャットを例にして、次の操作を試してみてください。',
        p3: '',
        p4: '',
        p5: '',
        p6: '',
        p7: '携帯電話システム応用通知設定が正常であることを確保する：「携帯電話設定＞通知＞ウィーチャット＞許可通知スイッチをオンにする＞ロック画面、通知センター、バナーをチェックする」、プレビュー選択を常に表示し、バナースタイル選択を継続します。',
        p8: '',
        p9: '',
        p10: '',
        p11: '',
        p12: '',
        p13: '',
        p14: '',
        p15: '',
        p16: '',
        p17: '',
        p18: '①設定通知に入る②Aswear Globalを見つける。',
        p19: '',
        p20: '',
        p21: '',
        p22: '',
        p23: '③通知許可スイッチをオンにする④ロック画面、通知センター、バナーをチェックする。',
        p24: '',
        p25: '',
        p26: '',
        p27: '',
        p28: '⑤プレビュー選択常時⑥バナースタイル選択継続を表示する。',
        p29: '',
        p30: '',
        p31: '',
        p32: '',
        p33: '',
        p34: '',
        p35: '',
        p36: '',
        p37: '2.腕時計との共有通知設定が正常であることを確認する：携帯電話での設定＞Bluetooth＞ペアリングされたデバイスをクリック＞共有システム通知を開く。',
        p38: '',
        p39: '',
        p40: '',
        p41: '',
        p42: '①Bluetoothの設定に進む②ペアリングされた設定をクリックする③共有通知を開きます。',
        p43: '',
        p44: '',
        p45: '2.Aswear Globalメッセージがプッシュされない場合は、アプリケーションAPPを開き、「マイ」>「マイデバイス」>「デバイス情報」>「メッセージ・リマインダ」を選択し、対応するメッセージ・タイプ通知スイッチを開きます。',
        p46: '',
        p47: '',
        p48: '',
        p49: '',
        p50: '①私の②ペアリングされたデバイスを選択する③メッセージアラームに入る④対応するメッセージタイプ通知スイッチをオンにする。',
        p51: '',
        p52: '',
        p53: '',
        p54: '',
        p55: '',
        p56: '',
        p57: '',
        p58: '',
        p59: '4.時計と携帯電話を再起動してみてください。',
        p60: '5.問題が残っている場合は、腕時計とAswear GlobalAPPを最新バージョンにアップグレードし、接続を再ペアリングします。',
        p61: '',
        p62: '',
        p63: '* Aswear Global APP更新：',
        p64: 'App StoreでAswear Global APPを検索し、インタフェースの指示に従ってダウンロード更新を行います。',
        p65: '*腕時計の更新経路：',
        p66: 'Aswear Global APP -> マイ -> マイデバイス -> デバイス情報 -> ファームウェアアップデート。',
        p67: '*ペアリング接続時に携帯電話システムがポップアップしてiPhone通知を表示できますか？許可をクリックします。',
        p68: '',
        p69: '',
        p70: '',
        p71: 'もし上記の方法があなたの問題を解決していないか、操作中に困難に遭遇した場合は、店舗のカスタマーサービスに連絡してください。私たちは心からあなたのためにサービスします。あなたの生活が楽しいことを祈ります。',
        p72: '1.腕時計との共有通知設定が正常であることを確認する：携帯電話での設定＞Bluetooth＞ペアリングされたデバイスをクリック＞共有システム通知を開く。',
        p73: '',
        p74: '',
        p75: '',
        p76: '',
        p77: '①Bluetoothの設定に進む②ペアリングされた設定をクリックする③共有通知を開く',
        p78: '',
        p79: '腕時計が携帯電話に出られない？（TA 700 S/G腕時計モデル向け）',
        p80: 'まず、時計と携帯電話が正常に接続されていることを確認し、次の操作を試みます。',
        p81: '①携帯電話の設定＞Bluetooth、接続されているデバイスを見つけ、デバイスをクリックします。',
        p82: '',
        p83: '',
        p84: '②再ロードが完了すると、接続済みステータスが表示され、右側の感嘆符をクリックして詳細ページに進み、デバイスタイプが別であることを確認します。',
        p85: '',
        p86: '',
        p87: '',
        p88: '',
        p89: '',
        p90: '',
        p91: '',
        p92: ''
    },
    problemType: {
        title: 'よくある質問',
        model: '型番'
    },
    problemList: {
        title: 'よくある質問',
        model: '型番',
        all: 'みんなが聞いている質問',
        zhibeizhen: '羅針盤の検査は正しくありませんか？',
        haiba: '標高が悪い？',
        android: 'Android携帯電話のメッセージは時計にプッシュできませんか？',
        ios: 'iOSの携帯電話のメッセージは時計にプッシュできませんか？',
        keepAlive: 'どのようにして保活設定を行いますか？',
        prompt: '携帯電話のオープン権限プロンプト「制限された設定」？',
        instructions: '操作の説明',
        sleep: '時計を正常に装着しても睡眠データはありません？',
        map: '地図をダウンロードする方法は？',
        ecg: '心電が測定できない/結果が正確ではない？'
    },
    privacyAgreement: {
        title: 'プライバシー契約',
        p0: '本契約はAswear GlobalAPP',
        p1: 'Aswear Globalはアストロリンクウォッチチーム（以下「私たち」）が運営するアウトドアスポーツとスマート健康監視を提供するシリーズ製品とサービスで、製品は主にスマート時計で、サービスは主にAndroid、IOS。',
        p2: 'Astrolinkの製品とサービスを使用することにより、お客様は本プライバシーポリシーに記載されているすべての条項をお読みになり、承認し、承諾し、デルがいつでも行うことができる変更を含むすべての条項を承諾しました。デルは、お客様の所在地のデータ保護に関する法律を含む法律を使用して、個人情報のプライバシー、機密、セキュリティを保護することを約束しています。同時に、私たちの従業員と代理店全員がこれらの義務を履行することを約束します。',
        p3: '',
        p4: '一、個人情報の収集と使用方法',
        p5: '個人情報とは、電子的または他の方法で記録された、単独でまたは他の情報と結合して特定の自然人の身元を識別したり、特定の自然人の活動状況に反応したりすることができる様々な情報を指す。',
        p6: '個人機密情報とは、身分証明書番号、個人生物識別情報、銀行口座番号、財産情報、行方軌跡、取引情報などを含む。',
        p7: '私たちは、この声明に記載されている以下の目的だけで、あなたの個人情報を収集して使用します。',
        p8: '1、アカウント登録',
        p9: '私たちはメールボックスを私たちのアカウントシステムとして使用しています。メールボックスを使用してログインすると、アカウントバインド用の認証コードが取得されます。',
        p9p0: '私たちはメールボックスを私たちのアカウントシステムとして使用しています。メールボックスを使用してログインすると、アカウントバインド用の認証コードが取得されます。',
        p9p1: '',
        p9p2: '',
        p9p3: '',
        p9p4: '',
        p9p5: '',
        p9p6: '',
        p9p7: '',
        p9p8: '',
        p9p9: '',
        p9p10: '',
        p10: 'なぜあなたの運動と健康データを管理するのか、私たちはあなたの性別、体重、身長、誕生日などを含むあなたのアカウントデータを使用する必要があります。性別、体重、身長、誕生日を使用するのはあなたにより良い健康アドバイスを提供するためです。',
        p10p0: '運動および健康データを管理するため、当社はお客様のアカウント情報を使用する必要があります。これには、',
        p10p1: '性別、体重、身長、生年月日などが含まれます。性別、体重、身長、生年月日を使用する目的は、',
        p10p2: 'より適切な健康アドバイスを提供するためです。',
        p11: 'アカウントデータを作成または変更すると、自動的に携帯電話のローカルに保存され、バックグラウンドサーバに同期されます。',
        p12: 'デバイスやアプリケーションにログインアカウント機能がなければ、このようなデータは記録されません。一部の製品はアカウントにログインしていないと、オンラインサービスを提供できません。ログイン後に性別や体重などの情報を提供しないと、提案の正確性に影響を与える可能性があります。',
        p12p0: 'デバイスやアプリケーションにアカウントログイン機能がない場合、当社はこのようなデータを記録しません。一部の製品では、アカウントにログインしていない場合、オンラインサービスを提供することができません。ログイン後、',
        p12p1: '性別や体重などの',
        p12p2: '情報を提供いただけない場合、当社が提供するアドバイスの正確性に影響が出る可能性があります。',
        p13: 'アカウントをログアウトしたい場合は、APPにログインして、「マイ」ページにアクセスして、「設定」欄をクリックして、「その他の設定」ページにアクセスして、「アカウントとセキュリティ」欄を選択して、「アカウントをログアウト」をクリックして、アカウントをログアウトした後、アカウントと関連情報を永久に削除します。',
        p105p0: 'アカウントログイン時には端末の',
        p105p1: '固有識別子（IMEI/AndroidID/IDFA/OPENUDID/GUID/OAID、SIMカードのIMSI情報など）',
        p105p2: 'を取得します。これは端末管理と本人確認のためであり、ログインの安全性を確保し、パスワード漏洩による他端末からの不正ログインを防止する目的です。',
        p14: '2、設備管理',
        p15: 'アストロリンク時計を管理するために、腕時計デバイス識別子（MAC、SNなど）、デバイスタイプ、デバイス構成パラメータなどを含むデバイス情報とネットワーク情報を収集する必要があります。このような情報を収集する目的は、Bluetooth接続を確立し、デバイス構成情報を管理し、ソフトウェアのアップグレードを完了し、データソースを表示することです。ネットワーク情報には、IPアドレス、ネットワークタイプ、ネットワーク接続状態などが含まれており、これらのデータは私たちの製品のネットワーク接続体験を向上させるために使用されます。',
        p15p0: '私たちはメールボックスを私たちのアカウントシステムとして使用しています。メールボックスを使用してログインすると、アカウントバインド用の認証コードが取得されます。',
        p15p1: '',
        p15p2: '',
        p15p3: '',
        p15p4: '',
        p15p5: '',
        p15p6: '',
        p16: '接続デバイスには携帯電話のBluetoothアクセス権が必要ですが、関連情報は保存されません。デルのウェアラブルデバイスは、アプリケーションを介して管理する際に、個人情報やデバイス構成情報を専用のセキュリティチャネルを介してウェアラブルappアプリケーションに転送します。',
        p16p0: '端末を接続するには、お客様のスマートフォンの',
        p16p1: 'Bluetooth権限',
        p16p2: 'へのアクセスが必要ですが、当社は関連情報を保存しません。当社のウェアラブル端末をアプリで管理する際、',
        p16p3: '個人情報および端末設定情報',
        p16p4: 'は専用の安全なチャネルを介してウェアラブルアプリに送信されます。',
        p17: 'このような情報を提供しないと、デルのウェアラブルデバイスや関連するバックグラウンドサービスを使用できないか、一部の機能が制限されています。',
        p18: '3、個人健康情報管理',
        p19: '心電収集機能を備えた設備とサービスの中で、あなたの健康データを記録し管理するために、私たちはあなたの運動設定データ（運動状態、心博総数、心率区間などを含む）を収集する必要があり、心率データは運動心率、日常心率及び心率データ分析を経て生成されたオンライン報告に分けられ、心率データは個人敏感情報に属し、このような情報を収集する目的は健康関連データの測定、記録、表示及び心電データ分析の正確性を増加し、私たちの製品のサービス品質を向上させるためである。本機能はご参考までに、医療診断の根拠としてはなりませんので、不調があればすぐに医療機関にお問い合わせください。',
        p19p0: '心電計測機能を備えた端末およびサービスにおいて、お客様の健康データを記録・管理するため、運動設定データ（',
        p19p1: '運動状態、総心拍数、心拍ゾーンなど',
        p19p2: '）を収集する必要があります。心拍データは、運動時心拍、日常心拍、および心拍データ分析から生成されるオンラインレポートに分類されます。',
        p19p3: '心拍データ',
        p19p4: 'は個人の機微情報に該当します。これらの情報を収集する目的は、健康関連データの測定・記録・表示を行うため、心電データ分析の精度を高め、製品サービスの品質向上を図るためです。本機能は参考情報として提供するもので、医療診断の根拠として使用することはできません。体調に不安がある場合は、直ちに医療機関に相談してください。',
        p20: 'このような情報を提供しないと、私たちのappアプリケーションの機能が制限され、通常のサービスを提供できなくなります。',
        p21: '4、運動データ記録',
        p22: '運動記録と統計機能を備えた設備とサービスでは、あなたの運動データを記録し管理するために、私たちはあなたの設備の位置、運動軌跡、運動タイプ、運動時間の長さ、ランニング姿勢、歩数、距離、高さ、運動心拍数などを収集する必要があります。運動タイプには、健走、ランニング、サイクリング、登山、水泳、マラソンなどがあります。位置と軌跡は個人の機密情報であり、このような情報を収集する目的は、APPで運動軌跡の表示機能を提供するために、日常の運動データを記録し、統計することです。',
        p22p0: '運動記録・統計機能を備えた端末およびサービスにおいて、お客様の運動データを記録・管理するため、',
        p22p1: '端末の位置情報、運動ルート',
        p22p2: '、運動種別、運動時間、ランニングフォーム、歩数、距離、高度、運動時心拍数などを収集します。運動種別には、ウォーキング、ランニング、サイクリング、登山、水泳、マラソンなどが含まれます。このうち',
        p22p3: '位置情報とルート情報',
        p22p4: 'は個人の機微情報に該当し、これらの情報を収集する目的は、日常の運動データを記録・分析し、アプリ内で運動ルート表示機能を提供するためです。',
        p23: '私たちはappアプリケーションで関連する運動データを統計して表示します。データを他の用途として使用する場合、匿名化処理を行った後も表示されます。',
        p24: 'このような情報を提供しない場合は、運動状況の統計、分析、表示を提供することはできません。',
        p25: '7、授権同意を得る例外',
        p26: '次の場合、天奥電子は個人情報を収集し、使用するために承認を得る必要はありません:',
        p27: '（1）国家の安全、国防の安全に関する；',
        p28: '（2）公共の安全、公共衛生、重大な公共利益に関連する；',
        p29: '（3）犯罪捜査、起訴、裁判、判決執行などに関連する；',
        p30: '（4）個人情報の主体やその他の個人の生命、財産などの重大な合法的権益を守るために本人の同意を得にくい場合；',
        p31: '（5）収集された個人情報は、個人情報の主体が自ら社会に公開したものである；',
        p32: '（6）合法的に公開された情報の中から収集された個人情報、例えば合法的な新聞報道、政府情報公開などのルート；',
        p33: '（7）ご要望に応じて契約を締結するために必要な；',
        p34: '（8）提供される製品および／またはサービスの安全で安定した運用を維持するために必要な、例えば製品および／またはサービスの障害の発見、処置；',
        p35: '（9）合法的な報道に必要な；',
        p36: '（10）学術研究機関が公共の利益に基づいて統計や学術研究に必要であり、かつ対外的に学術研究や記述の結果を提供する場合、結果に含まれる個人情報を非標識化処理する；',
        p37: '（11）法律法規に規定されたその他の状況。',
        p105: 'アカウント登録時にデバイスの一意のデバイス識別コード（IMEI/androidID/IDFA/OPENUDID/GUID/OAID、SIMカードIMSI情報など）を取得し、デバイス管理と認証に使用し、ユーザー登録の安全性を保証し、パスワード漏洩が他のデバイスによって異郷登録されることを防止する必要がある。',
        p38: '二、個人情報の処理、共有、譲渡、公開を依頼する方法',
        p39: '1、委託処理',
        p40: '特別な場合には、お客様の個人情報を処理するために他社の代表者に依頼する可能性があります。デルは、本声明に従って、個人情報を処理するために関連する秘密保護およびセキュリティ対策を講じるために、委託先と厳格な秘密保護契約または個人情報処理条項に署名します。',
        p41: '2、共有＃キョウユウ＃',
        p42: '共有とは、私たちが他の個人情報制御者に個人情報を提供し、双方がそれぞれ個人情報に対して独立した制御権を持つ過程を指す。私たちはあなたの個人情報を対外的に共有することはありませんが、以下の場合を除く：',
        p43: '（1）明示的な同意を得た場合の共有：明示的な同意を得た後、指定した第三者に承認範囲内の情報を共有します；',
        p44: '（2）法定状況下での共有：私たちは法律法規の規定、訴訟紛争の解決需要に基づいて、あるいは行政、司法機関が法に基づいて提出した要求に基づいて、対外的にあなたの個人情報を共有することができます；',
        p45: '3、譲渡とは',
        p46: '譲渡とは、個人情報制御権を私たちが別の個人情報制御者に移転する過程を指す。私たちはあなたの個人情報を会社、組織、個人に譲渡することはありませんが、以下の場合を除く：',
        p47: '（1）明確な同意を得た場合の譲渡：あなたの明確な同意を得た後、私たちは他の方にあなたの個人情報を譲渡します；',
        p48: '（2）合併、買収、または破産清算に関連する場合、個人情報の譲渡に関連する場合は、新たに個人情報を保有する企業、組織に対して引き続き本声明の制約を受ける必要があります。そうしないと、当社、組織に対してライセンス同意を求める必要があります。',
        p49: '4、公開',
        p50: '私たちは以下の場合にのみ、あなたの個人情報を公開します：',
        p51: '（1）あなたの明確な同意を得てから；',
        p52: '（2）法的根拠または合理的根拠に基づく開示：法的、法的手続き、訴訟、または公的および政府の主管部門から要求がある場合には、情報を開示することがあります；',
        p53: '5、個人情報の共有、譲渡、公開時事における事前承認の例外',
        p54: '以下の場合、個人情報の共有、譲渡、公開は事前に承認を得る必要はありません：',
        p55: '（1）国家の安全、国防の安全に関する；',
        p56: '（2）公共の安全、公共衛生、重大な公共利益に関連する；',
        p57: '（3）犯罪捜査、起訴、裁判、判決執行などに関連する；',
        p58: '（4）個人情報の主体やその他の個人の生命、財産などの重大な合法的権益を守るために本人の同意を得にくい場合；',
        p59: '（5）あなた自身が公開している個人情報；',
        p60: '（6）合法的に公開された情報の中から収集された個人情報、例えば合法的な新聞報道、政府情報公開などのルート；',
        p106: '6、マイクライセンスに基づく拡張機能',
        p107: 'スマート文字盤、音声アシスタントなどの音声対話機能を実現するために、システムのマイク権限をオンにすることを選択できます。スマート音声テクノロジーの使用中に入力した音声情報を機械認識、オンラインインタラクション、ニーズに合わせて収集します。この機能はシステム権限でオフにすることができ、オフにするとオンライン音声対話機能を実装できなくなる可能性がありますが、他の基本的な機能を楽しむことには影響しません。',
        p61: '三、データ主体の権利',
        p62: 'デルの製品/サービスを使用している間は、個人情報にアクセス、訂正、削除することができます。また、個人情報の使用に対する同意を撤回する権利を保障します：',
        p63: '1. 個人情報の取得；',
        p64: '2. 個人情報の削除を要求；',
        p65: '3. 個人情報の更新を要求；',
        p66: '4. お客様の個人情報を使用する権利の撤回。',
        p67: '四、データ保管場所と期間',
        p68: '1、保管場所',
        p69: '本サービスで収集・生成された個人情報は、フランクフルト。',
        p70: '2、保管期間',
        p71: '目的を達成するために必要な時間だけ個人情報を保持し、前述の保存時間を超えた後に個人情報を削除または匿名化して処理します。',
        p72: 'データセキュリティのために、あなたのデータはあなたのアカウントとバインドされ、あなたの心の電気、運動などの健康データは私たちのバックグラウンドサーバに保存され、あなた自身がデータを削除したり、アプリケーションアカウントを削除したりするまで、あなたのデータは同時に安全に削除されます。',
        p73: 'また、製品やサービスが停止した場合は、プッシュ通知、公告などの形式で通知し、合理的な期限内に個人情報を削除したり、匿名化したりします。',
        p74: '五、サードパーティが収集した情報',
        p75: 'デルが提供するサービスには、デルのサービスプロバイダに属するサードパーティ追跡ツールが含まれている可能性があります。このサードパーティは、Cookies、APIs（アプリケーションプログラミングインタフェース）、SDKs（ソフトウェアプログラム開発パッケージ）を使用して、デルを代表してユーザー情報を収集し、分析することができます。サードパーティは、お客様のデバイス識別子、MAC（メディアアクセス制御）アドレス、IMEI（モバイルデバイス国際IDコード）、地域（特定の言語を使用する場所）、地理的位置情報、IPアドレスなどの情報にアクセスし、それぞれのプライバシーポリシーの下でサービスを提供することを目的としています。デルのプライバシーポリシーは、サードパーティ追跡ツールの使用をカバーしません。これらの第三者にアクセスしたり、制御したりする権限はありません。',
        p76: '六、ユーザーのソフトウェアインストールリストを取得する',
        p77: 'アプリは携帯電話にインストールされているアプリストアのリストを取得します。この機能は各アプリケーションストアへの展示やジャンプにのみ使用され、ユーザーがアプリケーションを評価したり、コミュニケーションしたりするのに便利です。これらのアプリケーションストアにアクセスしたり制御したりする権限はありません。第三者のアプリケーションストアに個人情報を送信する権限もありません。',
        p78: '統合SDKサービスと権限の使用方法の説明',
        p79: '（1）友盟+SDK',
        p80: '当社の製品は友盟+SDKを統合しており、プログラムがあなたのデバイスMacアドレス、ユニークデバイス識別コード（IMEI/android ID/IDFA/OPENUDID/GUID、SIMカードIMSI情報）を収集して統計分析サービスを提供し、地理的位置較正レポートデータの正確性を通じて、基礎的な不正行為防止サービスを提供する必要があります。',
        p81: '（2）个推 SDK',
        p82: 'SDKを統合するには、プログラム携帯電話のデバイスプラットフォーム、デバイスメーカー、デバイスブランド、デバイスモデルおよびシステムバージョン、OAID、AndroidID、WIFI接続情報、キャリア情報を許可する必要があります。これにより、メッセージ送信の正確な発信とメッセージデバイスの正確な識別を保証することができます。',
        p83: '（3）Bugly SDK',
        p84: '当社の製品はBugly SDKを統合しており、Android携帯電話はあなたの携帯電話モデル、携帯電話ブランド、Androidシステムバージョン、Androidシステムapiクラス、メーカーシステムバージョン、cpuアーキテクチャタイプ、デバイスがrootされているかどうか、ディスク空間占有サイズ、sdcard空間占有サイズ、メモリ空間占有サイズ、ネットワークタイプ、アプリケーションが現在実行中のプロセス名、PIDを収集する必要があります。IOS携帯電話は、デバイスモデル、オペレーティングシステムバージョン、オペレーティングシステム内部バージョン番号、wifi状態、cpuプロパティ、メモリ空き領域、ディスク空間/ディスク空き領域、ランタイム携帯電話状態（プロセスが占めるメモリ、仮想メモリなど）、idfv、刑務所を越えるかどうか、地域コードを収集する必要があります。APPがバックグラウンドで実行中に異常が発生した場合、SDKはバックグラウンドでエンドユーザーの上記の個人情報を収集し、クラッシュ問題を調査処理することができます。',
        p85: 'ふろく：',
        p86: 'SDK統合と必要な権限リスト',
        p87: '友盟の統計',
        p88: 'ユーザーのアクティブ化などの運用データを統計するために必要',
        p89: 'ACCESS_NETWORK_STATE、' +
            'ACCESS_WIFI_STATE、' +
            'READ_PHONE_STATE',
        p90: '个推',
        p91: 'メッセージ送信用',
        p92: 'INTERNET、' +
            'ACCESS_NETWORK_STATE、' +
            'ACCESS_WIFI_STATE、' +
            'SCHEDULE_EXACT_ALARM、' +
            'BADGE_ICON、' +
            'READ_EXTERNAL_STORAGE、' +
            'WRITE_EXTERNAL_STORAGE、' +
            'READ_PHONE_STATE、' +
            'ネットワークアクセス権、' +
            'IDFA',
        p93: 'Bugly',
        p94: 'クラッシュ情報の収集に使用',
        p95: 'INTERNET、' +
            'ACCESS_NETWORK_STAT、' +
            'ネットワークアクセス権、',
        p96: '七、この宣言を更新する方法',
        p97: '私たちは本声明を適時に更新する権利を保留し、声明に変更が発生した場合、AppまたはWeChat公式アカウントプッシュ通知などの形式で変更後の声明をお見せします。お客様の同意を得た場合にのみ、更新された宣言に従って個人情報を収集、使用、保存します。',
        p98: 'この宣言は更新日から有効となります。',
        p99: '最終更新日：2025年3月27日',
        p100: 'Astrolink チーム',
        p101: '5、IPアドレス',
        p102: 'サーバを近くに割り当て、ユーザー全体の使用とアクセスを高速化するために、IPアドレスを収集します。',
        p103: '（4）PushReceiver SDK',
        p104: 'PushReceiver SDKは自己起動機能を備えており、本アプリケーションがオフまたはバックグラウンド運転状態で穴戸端プッシュを正常に受信できることを保証するために、機能とサービスの実現に必要なため、一定の周波数がシステム送信ブロードキャストを通じて本アプリケーションの自己起動または関連起動行為を起動することができる。本アプリケーションは、プッシュチャネルの安定性を確保し、正常かつタイムリーにアンドロイドデバイスにメッセージをプッシュするための（自己起動）能力を使用する必要があります。システムがブロードキャストを送信すると、PushReceiver SDKの自己起動動作が起動されます。PushReceiver SDK系が統合された方法でアプリケーションにアクセスしていることを考慮して、PushReceiver SDKが自起動すると、アプリケーションも自起動する。この行為はプッシュ機能とサービスを実現するために必要である。',
        p108: '（5）百度の地図 SDK',
        p109: '私たちの製品は百度地図SDKを統合して、プログラムがあなたのネットワークアクセス権限、位置権限などを取得することを許可する必要があります。ネットワークアクセス権限はあなたに測位機能を提供するためにアクセス測位サービスに使用され、同時にWiFi情報のアクセスはネットワーク測位に使用されます。本アプリケーションの天気機能、都市選択機能、運動機能などは位置測位を使用して関連サービスを提供する必要がある。',
        p110: '百度の地図',
        p111: '位置決め機能用',
        p112: 'ACCESS_FINE_LOCATION、ACCESS_COARSE_LOCATION、INTERNET'
    },
    samSet: {
        title: '携帯電話のオープン権限が示す「制限された設定」の解決策',
        p0: 'このような状況はモトローラ、サムスンなどの携帯電話によく見られ、次の2つの方法で処理することができる。',
        p1: '方法一：',
        p2: '1、携帯電話のデスクトップでAswear Global APPのアイコンを長押しする＞アプリケーション情報＞右上の3点メニュー＞制限設定を許可する。',
        p3: '2、携帯電話「設定」>「通知」>「デバイスとアプリケーション通知」>「Aswear Global APPの選択」>「通知アクセス権の付与」に進む。',
        p4: '方法二：',
        p5: '以下はサムスン携帯電話の処理方式である：',
        p6: '1、携帯電話の設定>アプリケーション>その他のオプション（下図の3点）に進む',
        p7: '2、せんたく ',
        p8: '特別なアクセス',
        p9: '3、せんたく ',
        p10: 'アクセスの通知',
        p11: '4、Aswear Globalを開く ',
        p12: '',
        p13: ''
    },
    water: {
        title: '水を飲む助手',
        time0: '日',
        time1: '周',
        time2: '月',
        time3: '年',
        math0: '最高',
        math1: '最低',
        today: '今日の飲用水量',
        surplus: '余剰',
        math2: '目標達成率',
        math3: '日平均最高',
        math4: '日平均最低',
        chartUnit: '日平均',
        descTitle: '水を飲むアドバイス',
        desc: '水は人体を構成する主要成分の一つであり、良好な健康状態を維持するためには、十分な水分摂取を確保することが必要である。それぞれの具体的なニーズは、年齢、性別、体重、活動レベル、環境によって異なります。通常、成人男性は1日2 ~ 3リットルの飲用水を推奨しているが、成人女性は1.5 ~ 2.5リットルで、具体的には個人の状況に応じて調整する必要がある。毎日時間通りに水を飲み、コップを使って水の量を追跡することは、健康的な水を飲む良い習慣を身につけるのに役立つ。',
        maxCountDesc: '飲水量が上限に達した~'
    },
    weight: {
        title: '体重記録',
        time0: '周',
        time1: '月',
        time2: '年',
        level0: '軽量',
        level1: '正常',
        level2: '過体重',
        level3: '肥満',
        desc0: 'BMI（Body Mass Index）は、体格指数とも呼ばれ、国際的に用いられる人間の肥満度と健康状態を測定するための一般的な基準です。計算式は：BMI = 体重 ÷ 身長²。（体重単位：キログラム；身長単位：メートル）。しかし、これは完璧なツールではなく、特に個体差が大きい場合の評価においては適していないことがあります。したがって、BMIを他の健康指標と組み合わせて使用することを推奨します、より包括的な健康評価を得るためです。',
        desc1: 'BMI範囲説明：',
        desc2: '<18.5 軽量',
        desc3: '18.5~23.9 正常',
        desc4: '24.0~29.9 過体重',
        desc5: '>30 肥満',
        change: '変化',
        popTitle: '記録今日の体重',
        height: '身長: ',
        heightPop: '身長'
    },
    planEdit: {
        title: '計画の編集',
        save: '保存',
        planName: '計画名',
        planNameDesc: '入力してください',
        action: 'アクション',
        actionAdd: 'アクションを追加',
        capacity: 'ようりょう',
        group: 'グループ化',
        weight: 'じゅうりょう',
        frequency: '回',
        distance: 'きょり',
        duration: '時間を使う',
        duration1: '時間を使う',
        common: '合',
        inputPlaceholder: '有効な必須項目を入力してください',
        actionListPlaceholder: '少なくとも1つのアクションを追加',
        success: '操作は成功しました！',
        maxTip: '最大20グループ追加'
    },
    actionLibrary: {
        title: 'アクションライブラリ',
        searchDesc: '入力してください',
        action1: '全身',
        action2: '肩と首',
        action3: '腕',
        action4: '胸',
        action5: '背中',
        action6: '腰と腹',
        action7: 'お尻と脚',
        action8: 'カスタム',
        confirm: '確認',
        customize: 'カスタムアクション',
        customizeDesc: '独自のアクションを作成する',
        instrument1: '徒手',
        instrument2: 'ダンベルベンチ',
        instrument3: 'ベンチプレスベンチ',
        instrument4: '竜門棚',
        instrument5: '懸垂機',
        instrument6: 'スイスボール',
        instrument7: '弾性紐',
        instrument8: '仰臥板',
        instrument9: 'バーベルベンチ',
        instrument10: 'ハックスクワットマシン',
        instrument11: 'レッグプレスマシン',
        instrument12: '縄跳び',
        instrument13: 'ロープマシン',
        instrument14: '牧師の腰掛け',
        instrument15: 'ヘキサゴンバーベル',
        instrument16: '脚曲げ機',
        instrument17: 'バーベル本',
        instrument18: '亜鈴',
        instrument19: '座り踵取り機',
        instrument20: '高位置プルダウン機',
        instrument21: 'Tバーベル',
        instrument22: 'スミスマシン',
        instrument23: '腹巻き機',
        instrument24: 'その他',
        instrument25: '縄',
        muscles1: '斜方筋',
        muscles2: '大胸筋',
        muscles3: '上腕二頭筋',
        muscles4: '上腕三頭筋',
        muscles5: '前腕筋群',
        muscles6: '広背筋',
        muscles7: '脊柱起立筋',
        muscles8: '臀筋',
        muscles9: '大腿後筋群',
        muscles10: '腹筋',
        muscles11: '大腿四頭筋',
        muscles12: '内転筋',
        muscles13: '外転筋',
        muscles14: '下腿筋群',
        muscles15: '三角筋',
        detailBtn: '紹介',
        maxTip: '最大10個のアクションを追加'
    },
    actionDesc: {
        title: 'アクションの詳細',
        part: '訓練部位',
        point: '動作の要点',
        delete: '削除'
    },
    actionEdit: {
        title: 'アクション編集',
        actionName: 'アクション名',
        actionNamePlaceholder: '動作名を入力してください',
        actionPart: '訓練部位',
        actionPartPlaceholder: 'トレーニング部位を選択してください',
        actionInstrument: '訓練器具',
        actionInstrumentPlaceholder: 'トレーニング機器をお選びください',
        recordType: 'レコードデータ',
        recordTypePlaceholder: 'レコードデータを選択してください',
        actionBanner: 'アクションカバー',
        actionBannerPlaceholder: 'アクションカバーをアップロードしてください',
        actionMuscles: '訓練筋群',
        actionMusclesPlaceholder: 'トレーニング筋群を選択してください',
        actionPoint: '動作の要点',
        actionPointPlaceholder: '動作の要点を入力してください',
        save: '保存',
        selectPlaceholder: '選択してください',
        recordType1: '荷重と回数',
        recordType2: '時間のみ',
        recordType3: '回数のみ',
        recordType4: '距離のみ',
        pointPlaceholder: 'この動作の正しい姿勢、技術的なポイント、注意事項を説明することができます。',
        delete: 'アクションの削除',
        deleteTitle: '削除のヒント',
        deleteDesc: '本当にアクションを削除しますか？',
        confirm: '確認',
        cancel: 'キャンセル'
    },
    setPlanDate: {
        title: '訓練日の設定',
        repeatWeek: 'くりかえし',
        startDate: '開始時間',
        endDate: '終了時間',
        week0: '月',
        week1: '火',
        week2: '水',
        week3: '木',
        week4: '金',
        week5: '土',
        week6: '日',
        confirm: '確認',
        cancel: 'キャンセル',
        repeatTips: '少なくとも1つの繰り返し期間を選択してください',
        repeatText: '',
        repeatText0: '月',
        repeatText1: '火',
        repeatText2: '水',
        repeatText3: '木',
        repeatText4: '金',
        repeatText5: '土',
        repeatText6: '日',
        repeatText7: '毎日',
        repeatTextSplit: '、',
        import: 'トレーニングカレンダーにインポート',
        isRemind: 'リマインダの設定',
        remindTime: 'リマインダ時間',
        planErrorMsg: '計画は存在しません。再試行を終了してください',
        maxTip: '最大10個のトレーニングプランを同時に導入'
    },
    planLibrary: {
        title: '計画ライブラリ',
        history: '履歴計画',
        create: '+作成',
        progress: '進行中',
        group: 'グループ化',
        capacity: 'ようりょう',
        action: 'アクション',
        groupCount: 'グループ化'
    },
    planDesc: {
        title: '計画の詳細',
        start: '訓練を開始する',
        edit: '編集',
        delete: '削除',
        out: '終了',
        outPlan: '計画を終了する',
        outPlanDesc: 'トレーニング計画を終了しても、前の運動記録をクリアせず、終了を確認しますか？',
        confirm: '確認',
        cancel: 'キャンセル',
        deleteTitle: 'リマインダの削除',
        deleteDesc: '現在の計画は進行中です。現在の計画を停止して削除しますか？',
        success: '削除に成功しました！'
    },
    trainCalendar: {
        title: 'カレンダ',
        seeDetail: '詳細の表示'
    },
    startTrain: {
        title: '訓練を開始する',
        finish: '完了',
        action: 'アクション',
        group: 'グループ化',
        capacity: 'ようりょう',
        rest: '休憩',
        duration: 'タイミング',
        startTiming: '開始',
        feel: 'トレーニング感覚',
        confirm: '確認',
        easy: 'ゆとりがある',
        normal: 'ちょうどよい',
        hard: '困難',
        feelInput: '今日のトレーニングの心得と注意すべきことを書いてください'
    },
    sportTrainDesc: {
        title: '運動の詳細',
        rest: '休憩時間',
        cal: '運動エネルギー消費',
        hr: '心拍数',
        hrUnit: 'bpm',
        max: '最高',
        min: '最小',
        avg: '平均',
        hrRange0: 'きょくげん区間',
        hrRange1: '無酸素区間',
        hrRange2: '持久力区間',
        hrRange3: '有酸素区間',
        hrRange4: 'ウォーミングアップ区間',
        trainEffect: 'トレーニング効果',
        trainFeel: 'トレーニング感覚',
        trainParts: '訓練部位',
        effect0: 'ふくげんりょく',
        effect1: 'ばくはつりょく',
        effect2: '持久力',
        effect3: 'パワー',
        effect4: '達成率',
        dataFrom: 'データは '
    },
    activeTarget: {
        title: 'ターゲット設定',
        step: '目標ステップ数',
        cal: '目標カロリー',
        strength: '目標中高強度時間',
        stepUnit: '步/日',
        calUnit: 'kcal/日',
        strengthUnit: '分/日'
    },
    userCheckup: {
        title: '診断報告書',
        all: 'すべて',
        normal: '通常',
        error: '例外',
        conclusion0: '明らかな異常は見られなかった',
        conclusion1: '項異常',
        numText0: '合計6項、検出成功',
        numText1: '項',
    },
    checkupDesc: {
        title: "レポート詳細",
        device: '検測デバイス',
        checkupTime: '検測時間',
        conclusion0: '今回完了',
        conclusion1: '件の検測',
        term: '件',
        normal: '指標正常',
        error: '指標異常',
        termTitle: '指標詳細',
        error1: '異常',
        hr: '平均心拍数',
        hrRefer: '参考値：60～100回/分',
        hrUnit: '回/分',
        hrDesc: '正常な心拍数の基準範囲は年齢や生理状態などの要因によって異なります。一般的に、成人の安静時心拍数は60～100回/分です。',
        bos: '血中酸素飽和度',
        bosRefer: '参考値：95%～100%',
        bosLevel0: '正常',
        bosLevel1: '軽度低酸素',
        bosLevel2: '中度低酸素',
        bosDesc: '一般的に、健康な成人の血中酸素飽和度の正常値範囲は95%～100%です。ただし、標高、活動レベル、個人の健康状態などの要因によって異なる場合があります。',
        pressure: '身体的ストレス',
        pressureLevel0: 'リラックス',
        pressureLevel1: '正常',
        pressureLevel2: '中程度',
        pressureLevel3: '高め',
        pressureDesc: '高いストレスを感じている場合、適切なストレス解消は健康に役立ちます。ストレス結果の説明：1-29 リラックス；30-59 正常；60-79 中程度；80-99 高め',
        temperature: '体温',
        temperatureRefer: '体温参考値：36～37℃',
        temperatureError: '＞38',
        skin: '皮膚温度：',
        temperatureDesc: '測定部位によって正常な体温範囲は異なります。腋下体温の場合、正常範囲は36℃～37℃です。皮膚温度とは皮膚表面の温度のことで、環境や生理状態などの要因によって大きく変動します。室温環境では、手首の皮膚温度はおよそ32.0～34.0℃です。',
        rate: '呼吸数',
        rateUnit: '回/分',
        rateRefer: '参考値：12～20回/分',
        rateDesc: '正常な呼吸数は年齢や生理状態などの要因によって異なります。一般的に、成人の安静時の正常な呼吸数は12～20回/分です。',
        ecg: '心電図',
        ecgScore: '点',
        ecgLevel0: '優',
        ecgLevel1: '良好',
        ecgLevel2: '普通',
        ecgLevel3: 'やや不良',
        ecgLevel4: '不良',
        ecgMore: '詳細を見る',
        tips: 'ご注意',
        tipsText: '本機能はスマートウォッチ内蔵のセンサーで健康関連データを収集し、アルゴリズムを用いて健康診断レポートを生成します。スマートウォッチのハードウェア制限や装着方法の違いにより、収集データには一定の誤差が生じる可能性があります。このレポートは個人の健康管理の参考としてのみご利用いただき、専門的な医療診断や医師の助言の代わりにはなりません。異常な結果や健康上の問題がある場合は、速やかに専門医療機関または医師に相談してください。'
    },
    deepSeek: {
        analysis: '解析中です、お待ちください',
        placeholder: '質問がある',
        ing: '現在のタスク回答',
        relief: 'AI生成コンテンツ。要確認。'
    },
    sportIndex: {
        title: 'スポーツ指標',
        pace: 'ペース',
        paceDesc: '1キロの距離を完了するのにかかる時間（単位：分/キロ）。',
        avgPace: '平均ペース',
        avgPaceDesc: '1回の運動におけるすべてのキロのペースの平均値。セグメントデータで個別の平均ペースも確認可能。',
        avgMovePace: '平均移動ペース',
        avgMovePaceDesc: '平均ペースと類似しているが、運動中の静止時間を除外し、実際の移動（走行、歩行などの持続的な前進状態）時のペースのみを計算するため、通常は平均ペースより速い。',
        bestPace: '最速1kmペース',
        bestPaceDesc: '今回の運動全体を通した中最も速い1kmのペースは、【分割データ】の最速ペースよりも速い場合があります。',
        bestPaceDesc1:  'デフォルトの1km分割を例に挙げると：',
        speed: '速度',
        speedDesc: '単位時間内に移動した距離（単位：キロ/時）。',
        avgSpeed: '平均速度',
        avgSpeedDesc: '運動全体の総距離 ÷ 総所要時間で、運動全体の平均的な速さを反映。',
        avgMoveSpeed: '平均移動速度',
        avgMoveSpeedDesc: '平均速度と類似しているが、運動中の静止時間を除外し、実際の移動時の速度のみを計算するため、通常は平均速度より速い。',
        bestSpeed: '最速1km速度',
        bestSpeedDesc: '今回の運動全体を通した中最も速い1kmの速度は、【分割データ】の最速速度よりも速い場合があります。',
        hrRange: '心拍ゾーン',
        hrRangeDesc: 'トレーニングをより効率的かつ安全にするため、最大心拍数（年齢・性別に基づく）に基づき、5つの強度ゾーンに分類：',
        hrRange0: '1. ウォームアップゾーン（50%~60%最大心拍数）：',
        hrRange0Desc: '低強度の運動で、主に運動前の準備や運動後のクールダウンに適する。',
        hrRange1: '2. 有酸素ゾーン（60%~70%最大心拍数）：',
        hrRange1Desc: '快適な強度で、呼吸が安定し会話が容易。長時間維持可能で、基礎的な有酸素能力向上に適する。',
        hrRange2: '3. エンデュランスゾーン（70%~80%最大心拍数）：',
        hrRange2Desc: '中高強度で、呼吸が深く速くなり、会話が困難になり始める。筋肉の疲労感が徐々に現れるが、一定時間維持可能。心肺機能向上や持久力強化に適する。',
        hrRange3: '4. 無酸素ゾーン（80%~90%最大心拍数）：',
        hrRange3Desc: '高強度で、呼吸が荒く会話がほぼ不可能。筋肉の痛みが明確に感じられ、持続時間が短い。スピード追求やパフォーマンス向上を目指す人（例：スプリントトレーニング）向け。',
        hrRange4: '5. 最大努力ゾーン（90%~100%最大心拍数）：',
        hrRange4Desc: '極限に近い/達する強度で、心肺・筋肉への負荷が極めて大きい。心拍数が激しく、呼吸が非常に荒く、会話不能。短時間しか維持できず、爆発力向上（例：短距離ダッシュ）に適するが、リスクが高いため専門家の指導が必要。',
        hrRecover: '心拍回復',
        hrRecoverDesc: '運動後、心拍数が正常に戻る能力。運動終了時と1分後の心拍数の差で測定。差が大きいほど回復能力が高いとされる。',
        strideF: '歩頻（キャデンス）',
        strideFDesc: 'ランニング/歩行中、1分間に両足が交互に着地する回数（単位：歩/分）。一般人：160–180歩/分、経験者：180–200歩/分。歩頻が高いと着地時間が短く、体への衝撃が減り、安定性向上や怪我予防に有効。初心者は「小さな歩幅で速いリズム」の練習（例：もも上げランニング）で180歩/分を目標に。過度な追求はフォーム崩れ（例：膝内転）の原因に。',
        stride: '歩幅',
        strideDesc: 'ランニング/歩行中、前後の足の着地間隔（単位：メートル/歩）。一般人：0.7–1.2m/歩、上級者：1.5m以上/歩。歩幅が大きいとエネルギー効率は向上するが、関節（特に膝・足首）への衝撃が増加。初心者/体重の重いランナーはまず歩頻を向上（例：180歩/分）させ、その後徐々に歩幅を拡大すること。',
        calories: '運動消費カロリー',
        caloriesDesc: '運動中に消費されたカロリー（単位：kcal）。',
        carbohydrate: '炭水化物',
        carbohydrateDesc: '運動時のエネルギー源は主に炭水化物（糖質）と脂肪で、その比率は運動強度・時間・個人の代謝差により変動。デバイスはアルゴリズムと生体データに基づき推定するが個人差があるため、トレンド（例：長期運動後の脂肪燃焼率向上）を重視し、単回の絶対値の精度は参考程度とする。',
        sweatLoss: '発汗量',
        sweatLossDesc: '運動強度・環境温度などに基づくアルゴリズム推定値。個人差（汗の量の体質差）は反映されない。',
        power: 'パワー',
        powerDesc: '運動強度・環境温度などに基づくアルゴリズム推定値。個人差（汗の量の体質差）は反映されない。',
        avgPower: '平均パワー',
        avgPowerDesc: 'ランニング中の総パワー出力の平均値。',
        maxPower: '最大パワー',
        maxPowerDesc: 'ランニング中の総パワー出力の平均値。',
        trainingLoad: 'トレーニング負荷',
        trainingLoadDesc: 'トレーニング強度と時間の累積効果。強度が高く時間が長いほど負荷が増加。',
        effect: '有酸素/無酸素効果',
        effectDesc: '心拍ゾーン維持時間と強度に基づく0-6.0の評価。数値が高いほど効果が顕著。有酸素効果の向上はVO2maxの上昇（例：同じペースで心拍数低下）、無酸素効果の向上は筋力・スピード向上（例：同じ重量でレップ数増加）の可能性を示唆。',
        vo2max: '推定最大酸素摂取量（VO2max）',
        vo2maxDesc: '最大強度運動時に体重1kgあたり1分間で摂取できる酸素の最大量（単位：ml/kg/分）。心肺持久力の指標で、値が高いほど酸素利用効率が良い。一定の強度・時間のランニング時に、運動データと生体特徴に基づきアルゴリズムで推定。',
        verSpeed: '垂直速度',
        verSpeedDesc: '単位時間内の上昇/下降する垂直高度（単位：メートル/時）。',
        rate: '呼吸数',
        rateDesc: '1分間の呼吸回数（単位：回/分）。安定したリズムは動作の安定性と集中力向上に寄与。',
        trips: 'ラップ数',
        tripsDesc: '水泳において、片道（例：50mプールの端から端まで）を1ラップとカウント。',
        avgSwolf: '平均SWOLF',
        avgSwolfDesc: '水泳効率指標。SWOLF = 1ラップタイム + ストローク数。値が小さいほど効率が高い。平均SWOLFは長距離泳ぎにおける1ラップあたりの平均値。',
        swimSpeed: '100mペース',
        swimSpeedDesc: '100mを泳ぎ切るのにかかる時間（単位：分/100m）。',
        frequency: '頻度',
        frequencyDesc: '1分間に「縄跳び + ジャンプ」の完全動作を完了する回数（単位：回/分）。',
        strokeRate: 'ストロークレート',
        strokeRateDesc: '1分間のストローク回数（単位：回/分）。左右腕各1ストロークを1回とカウント。',
        fitness: 'フィットネスレベル',
        fitnessDesc: '運動強度・持続時間・回復状態などに基づく、単回トレーニング中の身体機能変化の総合評価（範囲0-100%）。トレーニング計画の科学的参考値として利用可能だが、主観的な体感（疲労度・筋肉反応等）も併せて考慮する必要がある。',
    },
    importMp3: {
        title: 'SYNTIME 5 MP 3導入',
        p1: '注意：このチュートリアルはSyntime5ウォッチ用です。音楽はMP3形式のみ対応しています。',
        p2: 'iOSおよびAndroidスマートフォン経由で音楽をインポートする手順（WeChatアプリでMP3ファイルをダウンロードする例）：',
        title1: '【Androidスマートフォン】',
        title2: '【iOSスマートフォン】',
        p3: '1. WeChatアプリ内のMP3ファイルをスマートフォンに保存',
        p4: '1) WeChatを開き、対象の音楽ファイルを見つけてタップ；',
        p5: '2) ボタンをタップし、表示されるダイアログで「保存」を選択すると、ファイルがスマートフォンに保存されます（下図参照）：',
        p6: '2. Aswearアプリで音楽をウォッチにインポート',
        p7: '1) デバイス → 音楽管理を開き、音楽管理ページに移動',
        p8: '2) 【音楽を追加】をタップし、ファイル選択ページでダウンロードしたMP3ファイルを選択してインポートします（処理に時間がかかる場合がありますので、しばらくお待ちください）；',
        p9: '1. WeChatアプリ内のMP3ファイルをスマートフォンに保存',
        p10: '1) WeChatを開き、対象の音楽ファイルを見つけてタップ；',
        p11: '2) ボタンをタップし、表示されるダイアログで【他のアプリで開く】を選択（下図参照）：',
        p12: '3) 表示されるダイアログで【「ファイル」に保存】を選択し、スマートフォンに保存します（下図参照）：',
        p13: '2. Aswearアプリで音楽をウォッチにインポート',
        p14: '1) デバイス → 音楽管理を開き、音楽管理ページに移動',
        p15: '2) 【音楽を追加】をタップし、ファイル選択ページでダウンロードしたMP3ファイルを選択してインポートします（処理に時間がかかる場合がありますので、しばらくお待ちください）。',
    },
    report: {
        title: '報告',
        type: [
            '有害/危険',
            'わいせつ/低俗',
            '誹謗中傷/攻撃',
            '違法行為',
            'プライバシー関連',
            '著作権・名誉毀損等',
            'その他'
        ],
        content: '報告理由をご記入ください。問題となった内容を説明してください',
        submit: '送信'
    },
    nfc: {
        title: 'よくある質問',
        title1: '対応範囲:',
        p1: '1. 現在、市販されている暗号化されておらず、周波数が13.56MHzの非接触ICカード（門カード）のみ対応しています;',
        p2: '2. 門カード機能付きの銀行カードや、チャージ・交通系決済機能が搭載された門カードは現時点ではシミュレートできません。仮にシミュレートに成功しても、銀行や交通系の機能は利用できません。',
        title2: '門カードの使用方法:',
        p3: 'スマートウォッチの「門カード」機能を開き、該当する門カードの画面に切り替えてください。カードが有効化され「読み取りエリアに近づけてください」と表示されたら、スマートウォッチの表面を門禁装置に近づけて直接カード読み取りを行ってください。',
        title3: '門カードの登録制限:',
        p4: '最大4枚の門カードを登録できます。',
        title4: 'カードで反応しなかったらどうする？',
        p5: '「一部のドアロックは腕時計のドアロックカードのカード払いをサポートしていないか、異なるシャッタの検査情報が一致していないため、一部のシャッタカードのカード払いに失敗する可能性があります（例えば、団地のドアロックカードはブラシでき、エレベーターはブラシできません）、実体のドアロックカードを使用することをお勧めします。',
        title5: 'シミュレーションやカード決済に失敗したらどうしますか。',
        p6: '何度もシミュレーションを試みたり、カードで失敗したりした場合は、カードを書いた後もカードで払うことができないなど、ブランクカードを作成して不動産カードを書いてください。チップとシャッタが互換性がない可能性があります。元のエンティティゲートカードを使用することをお勧めします。',

    },
    recovery: {
        title: '回復',
        trends: '回復の傾向',
        average: '平均',
        avgScore: '平均スコア',
        vsLastWeek: '(先週比)',
        vsLastMonth: '(先月比)',
        days: '日',
        scoreGt75: '(>75%)',
        score50to75: '(50%~75%)',
        scoreLt50: '(<50%)',
        scoreGe80: '(≥80)',
        score60to79: '(60~79)',
        scoreLe60: '(＜60)',
        suggestText: '今週の回復状態は良好です！この調子で続けましょう。',
        hrvAndHr: 'HRV & 安静時心拍数',
        heartRate: '心拍数',
        avgHeartRate: '平均心拍数',
        hrv: 'HRV',
        avgHrv: '平均HRV',
        restingHr: '安静時心拍数',
        avgRestingHr: '平均安静時心拍数',
        respiratoryRate: '呼吸数',
        avgRespiratoryRate: '平均呼吸数'
    },
    activity: {
        title: 'アクティビティ',
        scoreTitle: 'アクティビティスコア',
        activityScore: 'アクティビティスコア',
        moderateVigorousTime: '中高強度運動時間',
        avgModVigTime: '平均中高強度運動時間',
        calories: 'カロリー',
        avgCalories: '平均カロリー',
        steps: '歩数',
        avgSteps: '平均歩数',
        stepsUnit: '歩',
        minUnit: '分',
        vigorous: '高強度',
        moderate: '中強度',
        basalBurn: '基礎消費',
        activityBurn: '活動消費'
    },
    waterSet: {
        title: '設定',
        dailyTarget: '日次目標',
        cup: 'カップ量',
        reminder: '日次リマインダー',
        reminderStart: 'リマインダー開始時間',
        reminderEnd: 'リマインダー終了時間',
        reminderFrequency: 'リマインダー頻度',
        frequency0: '30分毎',
        frequency1: '1時間毎',
        frequency2: '2時間毎',
        save: '保存',
        success: '保存が成功しました'
    },
    vitalSigns: {
        title: 'バイタルサイン',
        heartRate: '心拍数',
        restingHr: '安静時心拍数',
        hrv: 'HRV',
        spo2: 'SpO2',
        respRate: '呼吸数',
        unitBpm: 'bpm',
        unitMs: 'ms',
        unitPercent: '%',
        unitBrMin: '回/分',
        within: '範囲内 ',
        outside: '範囲外 ',
        latest: '最新',
    }
};

export default zh;



// WEBPACK FOOTER //
// ./src/i18n/langs/ja.js